// src/config/mapConfigs.js
import pondImg from "../.././../assets/images/maps/map99.png";
import lowVisImg from "../.././../assets/images/maps/map15.png";
import safariImg from "../.././../assets/images/maps/map10.png";
import ruinImg from "../.././../assets/images/maps/map20.png";
import treasureImg from "../.././../assets/images/maps/map21.png";
import iceImg from "../.././../assets/images/maps/map23.png";
import safariOverImg from "../.././../assets/images/maps/map10over.png";
import charSprite    from "../../../assets/images/characters/Pokemon-Red.png";
import emeraldSprite    from "../../../assets/images/characters/Pokemon-Emerald.png";
import route25Img from "../.././../assets/images/maps/map24.png";
import deptStore1Img from "../../../assets/images/maps/department-store.png";
import deptStore2Img from "../../../assets/images/maps/department-store-2.png";
import deptStore3Img from "../../../assets/images/maps/department-store-3.png";
import promoCenterImg from "../../../assets/images/maps/promo-center.png";
import gamesCornerImg from "../../../assets/images/maps/games-corner.png";
import player_shopImg from "../../../assets/images/maps/Item_Market.png";
import rusturfTunnelImg from "../.././../assets/images/maps/rock-map.png";
import emberspaImg from "../.././../assets/images/maps/ember.png";
import safarizonenorthImg from "../.././../assets/images/maps/safrai-zone-north.png";
import safarizoneeastImg from "../.././../assets/images/maps/safrai-zone-east.png";
import safarizonesouthImg from "../.././../assets/images/maps/Safrai-zone-south.png";
import safarizonewestImg from "../.././../assets/images/maps/safrai-zone-west.png";
import entranceImg from "../.././../assets/images/maps/entrance.png";
import magmaTower1Img from "../../../assets/images/maps/magma-tower.png";
import magmaTower2Img from "../../../assets/images/maps/magma-tower2.png";
import magmaTower3Img from "../../../assets/images/maps/magma-tower3.png";
import groudonChamberImg from "../../../assets/images/maps/groudon.png";
import islandImg from "../.././../assets/images/maps/Island_Map.png";
import fishingShopImg from "../.././../assets/images/maps/FishingShop.png";

import {
    lureImg,
    superLureImg,
    ultraLureImg
  } from "./../../../constants/items";

// Import Halloween Event map image
import halloweenEventImg from "../../../assets/images/maps/Halloween_Event.png";

export const mapConfigs = {
  pond: {
    id: 99,
    battleBackground: "/Battle/water.png",
    image: pondImg,
    characterSprite: charSprite,
    lureImages: {
        lureImg,
        superLureImg,
        ultraLureImg
      },
    width: 800,
    height: 800,
    tileSize: 8,
    viewport: { width: 336, height: 240 },
    initialPlayer: { x: 420, y: 720, direction: "up", step: 0 },
    collisionAreas: [
        { x: 200, y: 270, width: 420, height: 20 },
  { x: 620, y: 185, width: 5, height: 80 },
  { x: 665, y: 185, width: 2, height: 420 },
  { x: 0, y: 600, width: 670, height: 2 },
  { x: 620, y: 185, width: 50, height: 5 },
  { x: 170, y: 180, width: 7, height: 100 },
  { x: 140, y: 180, width: 2, height: 320 },
  { x: 100, y: 500, width: 40, height: 5 },
  { x: 100, y: 500, width: 5, height: 100 },
  { x: 0, y: 600, width: 100, height: 5 },
  { x: 185, y: 677, width: 45, height: 1 },
  { x: 233, y: 630, width: 1, height: 45 },
  { x: 151, y: 634, width: 1, height: 40 },
  { x: 101, y: 634, width: 1, height: 40 },
  { x: 81, y: 684, width: 1, height: 45 },
  { x: 165, y: 610, width: 1, height: 20 },
  { x: 165, y: 635, width: 10, height: 1 },
  { x: 165, y: 635, width: 10, height: 1 },
  { x: 220, y: 610, width: 1, height: 20 },
  { x: 264, y: 200, width: 100, height: 20 },
  { x: 454, y: 200, width: 100, height: 20 },
  { x: 454, y: 0, width: 1, height: 190 },
  { x: 364, y: 0, width: 1, height: 190 },
  { x: 264, y: 0, width: 1, height: 190 },
  { x: 154, y: 35, width: 80, height: 5 },
  { x: 4, y: 15, width: 120, height: 5 },
  { x: 20, y: 35, width: 1, height: 60 },
  { x:40, y: 110, width: 15, height: 70 },
  { x:60, y: 140, width: 5, height: 5 },
  { x:15, y: 290, width: 5, height: 5 },
  { x:40, y: 315, width: 5, height: 5 },
  { x:35, y: 365, width: 10, height: 5 },
  { x:60, y: 255, width: 10, height: 105 },

  { x: 0, y: 15, width: 1, height: 500 },



  { x:168, y: 720, width: 110, height: 80 },
  { x:300, y: 780, width: 10, height: 10 },
  { x:335, y:765, width: 10, height: 12 },
  { x:345, y:765, width: 200, height: 12 },
  
  { x:580, y:780, width: 10, height: 12 },
  { x:600, y:758, width: 10, height: 18 },
  { x:640, y:742, width: 5, height: 18 },
  { x:660, y:765, width: 10, height: 32 },
  { x:680, y:745, width: 100, height: 48 },

  { x:762, y:684, width: 10, height: 60 },
  { x:777, y:584, width: 10, height: 150 },

  { x:702, y:684, width: 10, height: 5 },
  { x:746, y:562, width: 10, height: 5 },
  { x:777, y:530, width: 15, height: 5 },

  { x:760, y:302, width: 15, height: 190 },
  { x:736, y:200, width: 35, height: 85 },

  { x:780, y:200, width: 5, height: 5},
  { x:780, y:160, width: 5, height: 5},

  { x:770, y:135, width: 25, height: 1},

  { x:770, y:5, width: 1, height: 100},
  { x:700, y:5, width: 10, height: 90},
  { x:740, y:40, width: 10, height: 5},
  { x:580, y:40, width: 180, height: 5},
  
  { x:650, y:80, width: 10, height: 5},
  { x:650, y:70, width: 10, height: 5},
  { x:620, y:95, width: 10, height: 5},
  { x:600, y:80, width: 10, height: 5},
  { x:585, y:60, width: 10, height: 5},

  { x:545, y:5, width: 1, height: 180},
  { x:92, y: 756, width: 10, height: 10 },
  { x:140, y: 760, width: 20, height: 20 },
  { x:110, y: 780, width: 20, height: 20 },
    ],
   
  },
  island: {
    id: 1,
    battleBackground: "/Battle/water.png",
    image: islandImg,
    characterSprite: emeraldSprite,
    lureImages: {
        lureImg,
        superLureImg,
        ultraLureImg
      },
    width: 480,
    height: 420,
    tileSize: 8,
    viewport: { width: 336, height: 240 },
    initialPlayer: { x: 208, y: 144, direction: "down", step: 0 },
    collisionAreas: [
      { x: 78, y: 195, width: 1, height: 215,  "padX": 6, "padY": 12},
      { x: 0, y: 185, width: 90, height: 1,  "padX": 6, "padY": 12},
       { x: 0, y: 145, width: 90, height: 1,  "padX": 6, "padY": 12},
        { x: 78, y: 0, width: 1, height: 140,  "padX": 6, "padY": 12},

         { x: 398, y: 195, width: 1, height: 215,  "padX": 6, "padY": 12},
         { x: 388, y: 185, width: 90, height: 1,  "padX": 6, "padY": 12},
       { x: 388, y: 145, width: 90, height: 1,  "padX": 6, "padY": 12},
        { x: 398, y: 0, width: 1, height: 140,  "padX": 6, "padY": 12},
         { x: 483, y: 0, width: 1, height: 230,  "padX": 6, "padY": 12},

        { x: 22, y: 393, width: 405, height: 1,  "padX": 6, "padY": 12},
    ],
    teleportZones: [
      { x: 448, y: 159, width: 1, height: 3, targetFloor: "radiantIsleRH", targetX: 24, targetY: 144 },
    ],
    npcs: [
      {
        id: "IslandNpc",
        x:  80,
        y: 149,
        width:  16,
        height: 24,
        sprite: "/Trainers/island_npc.png",
        modalType: "island",
        name: "Island NPC"
      },
      {
        id: "IslandNpc2",
        x:  80,
        y: 164,
        width:  16,
        height: 24,
        sprite: "/Trainers/island_npc.png",
        modalType: "island",
        name: "Island NPC"
      },
      {
        id: "IslandNpc4",
        x:  380,
        y: 194,
        width:  16,
        height: 24,
        sprite: "/Trainers/island_npc2.png",
        modalType: "island",
        name: "Island NPC"
      },
    ],
   
  },
  myisland: {
    id: 103,
    image: "/Maps/myisland.png",
    battleBackground: "/Battle/water.png",
    characterSprite: emeraldSprite,
    lureImages: {
      lureImg,
      superLureImg,
      ultraLureImg
    },
    width: 1000,
    height: 1000,
    tileSize: 8,
    viewport: { width: 336, height: 240 },
    initialPlayer: { x: 80, y: 496, direction: "right", step: 0 },
    collisionAreas: [
      { x: 26, y: 0, width: 48, height: 1000, "padX": 0, "padY": 0 },
    ],
    npcs: [
      {
        id: "MyIslandBerryShopOwner",
        x: 296,
        y: 280,
        width: 16,
        height: 24,
        sprite: "/Trainers/shopownerfront.png",
        dialogue: "Welcome to the Berry Shop! Need supplies, want to sell berries, or repair gear?",
        modalType: "berry-shop",
        name: "Berry Shop Owner",
      },
    ],
  },
  radiantIsleRH: {
    id:100,
    image: "/Maps/RadiantIsleRH.png",
    battleBackground: "/Battle/water.png",
    characterSprite: emeraldSprite,
    lureImages: {
      lureImg,
      superLureImg,
      ultraLureImg
    },
    width: 448,
    height: 384,
    tileSize: 8,
    viewport: { width: 336, height: 240 },
    initialPlayer: { x: 40, y: 144, direction: "right", step: 0 },
    collisionAreas: [
      { x: -7, y: -1, width: 49, height: 144,  "padX": 2, "padY": 7},
      { x: -7, y: 190, width: 49, height: 144,  "padX": 2, "padY": 7},
      { x: 40, y: 248, width: 110, height: 144,  "padX": 2, "padY": 7},
      { x: 135, y: 173, width: 10, height: 78,  "padX": 2, "padY": 7},
      { x: 137, y: 168, width: 270, height: 56,  "padX": 2, "padY": 7},
      { x: 397, y: 226, width: 12, height: 50,  "padX": 2, "padY": 7},
      { x: 397, y: 320, width: 20, height: 60,  "padX": 2, "padY": 7},
      { x: 420, y: 325, width: 20, height: 60,  "padX": 2, "padY": 7},
      { x: 185, y: 1, width: 120, height: 115,  "padX": 2, "padY": 7},
      { x: 160, y: 224, width: 115, height: 75,  "padX": 2, "padY": 7},
      { x: 276, y: 224, width: 95, height: 38,  "padX": 2, "padY": 7},
       { x: 330, y: 258, width: 30, height: 20,  "padX": 2, "padY": 7},
        { x: 275, y: 258, width: 20, height: 10,  "padX": 2, "padY": 7},
        { x: 64, y: 5, width: 65, height: 56,  "padX": 2, "padY": 7},
         { x: 107, y: 58, width: 20, height: 20,  "padX": 10, "padY": 7},
          { x: 128, y: 50, width: 14,height: 20,  "padX": 10, "padY": 7},
          { x: 66, y: 58, width: 20, height: 20,  "padX": 10, "padY": 7},
          { x: 224, y: 292, width: 45, height: 15,  "padX": 10, "padY": 7},
          { x: 160, y: 292, width: 45, height: 15,  "padX": 10, "padY": 7},
          { x: 312, y: 0, width: 150, height: 100,  "padX": 10, "padY": 7},
           { x: 312, y: 96, width: 58, height: 23,  "padX": 10, "padY": 7},
           { x: 402, y: 96, width: 58, height: 23,  "padX": 10, "padY": 7},




    ],
    teleportZones: [
       { x: 4, y: 144, width: 1, height: 1, targetFloor: "island", targetX: 360, targetY: 144 },
       { x: 80, y: 56, width: 1, height: 1, targetFloor: "fishingShop", targetX: 32, targetY: 72 },
        { x: 368, y: 96, width: 1, height: 1, targetFloor: "watergym", targetX: 128, targetY: 272 },
        { x: 296, y: 264, width: 1, height: 1, targetFloor: "berryShop", targetX: 24, targetY: 120 },
       { x: 200, y: 306, width: 1, height: 1, targetFloor: "nosepassCave", targetX: 248, targetY: 144 },
    ],
    npcs:[
      {
       id: "FisherContestOfficer",
       x:  78,
       y: 216,
       width:  16,
       height: 24,
       sprite: "/Trainers/fisher-missions.png",
       dialogue: "Hi, I'm here needing help with some fishing missions! I'll give you a fishing mission every day at 6am. The rewards depend on the mission you complete.",
       modalType: "fishing-missions",
       name: "Fred Fisher"
      },
      {
       id: "WaterGymBlocker",
       x:  376,
       y: 112,
       width:  16,
       height: 24,
       sprite: "/Trainers/trainer-owner.png",
       direction: 3,
       step: 0,
       hideIfSpecialTrainerDefeated: 15,
       dialogue: "The gym is under maintenance. If you're looking for a battle, try the old man in Nosepass Cave.",
       name: "Guard"
      },
    ]
  },
   watergym: {
    id:101,
    image: "/Maps/WaterGym.png",
    battleBackground: "/Battle/water.png",
    gymGate: { leaderTrainerId: 19, requiredTrainerIds: [16, 17, 18] },
    characterSprite: emeraldSprite,
    lureImages: {
      lureImg,
      superLureImg,
      ultraLureImg
    },
    width: 320,
    height: 320,
    tileSize: 8,
    viewport: { width: 320, height: 240 },
    initialPlayer: { x: 128, y: 280, direction: "up", step: 0 },
    collisionAreas: [
       { x: 62, y: 220, width: 165, height: 60,  "padX": 15, "padY": 10},
       { x: 92, y: 209, width: 135, height: 58,  "padX": 12, "padY": 2},
        { x: 110, y: 48, width: 118, height: 135,  "padX": 8, "padY": 10},
        { x: 95, y: 170, width: 118, height: 18,  "padX": 7, "padY": 15},
        { x: -4, y: 170, width: 25, height: 150,  "padX": 14, "padY": 15},
        { x: 23, y: 223, width: 25, height: 68,  "padX": 15, "padY": 15},
        { x: 10, y: 290, width: 25, height: 68,  "padX": 15, "padY": 15},
        { x: -5, y: 110, width: 118, height: 65,  "padX": 10, "padY": 10},
       { x: 175, y: 257, width: 82, height: 58,  "padX": 10, "padY": 10},
       { x: 270, y: 257, width: 82, height: 58,  "padX": 10, "padY": 10},
       { x: 224, y: 63, width: 48, height: 78,  "padX": 10, "padY": 10},
       { x: 289, y: 63, width: 48, height: 78,  "padX": 10, "padY": 10},
        { x: 110, y: -20, width: 118, height: 52,  "padX": 20, "padY": 20},
    ],
    teleportZones: [
       { x: 128, y: 314, width: 1, height: 1, targetFloor: "radiantIsleRH", targetX: 368, targetY: 128 },
    ],
    npcs:[
    ]
  },
    berryShop: {
    id: 104,
    image: "/Maps/BerryShopInterior.png",
    battleBackground: "/Battle/water.png",
    characterSprite: emeraldSprite,
    lureImages: {
      lureImg,
      superLureImg,
      ultraLureImg
    },
    width: 448,
    height: 384,
    tileSize: 8,
    viewport: { width: 336, height: 240 },
    initialPlayer: { x: 40, y: 144, direction: "right", step: 0 },
    collisionAreas: [
        { x: 90, y: 160, width: 10, height: 32,  "padX": 15, "padY": 15},
        { x: 120, y: 160, width: 10, height: 32,  "padX": 2, "padY": 7},
        { x: 144, y: 160, width: 10, height: 32,  "padX": 2, "padY": 7},
        { x: 175, y: 160, width: 10, height: 32,  "padX": 2, "padY": 7},
        { x: 0, y: 160, width: 16, height: 32,  "padX": 2, "padY": 7},
        { x: 2, y: 0, width: 189, height: 32,  "padX": 2, "padY": 7},
        { x: 15, y: 24, width: 16, height: 78,  "padX": 2, "padY": 7},



        { x: 5, y: 200, width: 300, height: 32,  "padX": 2, "padY": 7},
        { x: 205, y: 10, width: 5, height: 300,  "padX": 2, "padY": 7},
    ],
    teleportZones: [
       { x: 42, y: 190, width: 1, height: 1, targetFloor: "radiantIsleRH", targetX: 296, targetY: 288 },
    ],
    npcs:[
       {
        id: "Berryshopowner",
        x:  0,
        y: 24,
        width:  16,
        height: 24,
        sprite: "/Trainers/shopownerfront.png",
        dialogue: "Welcome to the Berry Shop! Need supplies, want to sell berries, or repair gear?",
        modalType: "berry-shop",
        name: "Berry Shop Owner"
      },
        {
        id: "Berrymissions",
        x:  0,
        y: 64,
        width:  16,
        height: 24,
        sprite: "/Trainers/berry2.png",
        dialogue: "I’ll give you a farming mission every day at 6am. Harvest berries to earn rewards — or change the mission for 500 coins.",
        modalType: "farming-missions",
        name: "Farming Missions"
      },
      {
        id: "BerryFusionStation1",
        x:  82,
        y: 65,
        width:  28,
        height: 24,
        dialogue: "A Berry Fusion Station. Combine berries into powerful items.",
        modalType: "berry-fusion",
        name: "Berry Fusion"
      },
       {
        id: "BerryFusionStation2",
        x:  145,
        y: 65,
        width:  28,
        height: 24,
        dialogue: "A Berry Fusion Station. Combine berries into powerful items.",
        modalType: "berry-fusion",
        name: "Berry Fusion"
      },
    ]
  },
   fishingShop: {
    image: "/Maps/FishingShop.png",
    battleBackground: "/Battle/water.png",
    characterSprite: emeraldSprite,
    lureImages: {
      lureImg,
      superLureImg,
      ultraLureImg
    },
    width: 448,
    height: 384,
    tileSize: 8,
    viewport: { width: 336, height: 240 },
    initialPlayer: { x: 32, y: 72, direction: "up", step: 0 },
    collisionAreas: [
       { x: 87, y: 54, width: 10, height: 5, "padX": 2, "padY": 7},
       { x: 16, y: 24, width: 7, height: 64, "padX": 2, "padY": 7},
        { x: 3, y: 0, width: 127, height: 16, "padX": 2, "padY": 7},

        { x: 140, y: 0, width: 1, height: 116, "padX": 2, "padY": 7},

         { x: 1, y: 125, width: 201, height: 1, "padX": 2, "padY": 7},
    ],
    teleportZones: [
       { x: 32, y: 124, width: 1, height: 1, targetFloor: "radiantIsleRH", targetX: 80, targetY: 80 }
    ],
    npcs:[
       {
        id: "FisherShop",
        x:  0,
        y: 24,
        width:  16,
        height: 24,
        sprite: "/Trainers/fisher-shop.png",
        modalType: "fishing-shop",
        name: "Fred Fisher"
      },
    ]
  },

  nosepassCave: {
    id: 102,
    image: "/Maps/nosepasscave.png",
    battleBackground: "/Battle/water.png",
    characterSprite: emeraldSprite,
    lureImages: {
      lureImg,
      superLureImg,
      ultraLureImg
    },
    width: 320,
    height: 320,
    tileSize: 8,
    viewport: { width: 320, height: 240 },
    initialPlayer: { x: 208, y: 144, direction: "left", step: 0 },
    collisionAreas: [
       { x: 5, y: -9, width: 20, height: 60,  "padX": 2, "padY": 7},
        { x: 5, y: -9, width: 119, height: 20,  "padX": 2, "padY": 7},
         { x:198, y: -9, width: 119, height: 20,  "padX": 2, "padY": 7},
       { x: -12, y: 52, width: 20, height: 250,  "padX": 1, "padY": 6},
        { x: 87, y: 20, width: 37, height: 40,  "padX": 16, "padY": 8},
        { x: 127, y: 5, width: 15, height: 69,  "padX": 14, "padY": 8},
        { x: 180, y: 5, width: 15, height: 69,  "padX": 14, "padY": 8},
        { x: 199, y: 20, width: 37, height: 40,  "padX": 16, "padY": 8},
        { x: 312, y: 52, width: 20, height: 250,  "padX": 1, "padY": 6},
         { x:198, y: -9, width: 119, height: 20,  "padX": 2, "padY": 7},
          { x:288, y: 8,width: 112,height: 40,  "padX": 2, "padY": 7},
        { x:16,y:307,width: 280,height:23,  "padX": 2, "padY": 7},
        { x:32,y:15,width: 48,height:23,  "padX": 2, "padY": 7},
        { x:240,y:15,width: 48,height:23,  "padX": 2, "padY": 7},
    ],
    teleportZones: [
       { x: 292, y: 144, width: 1, height: 1, targetFloor: "RadiantIsleRH", targetX: 200, targetY: 328 },
    ],
    npcs:[
       {
        id: "NosepassTrainer",
        x:  152,
        y: 16,
        width:  16,
        height: 24,
        sprite: "/Trainers/mystery-man.png",
        trainer_id: 15,
        direction: 3,
        step: 0,
        dialogue: "A mysterious man hums an eerie tune.",
        name: "Mystery Man"
      },
    ]
  },
  lowvis: {
    id: 15,
    image: lowVisImg,
    battleBackground: "/Battle/LowVisBG.png",
    characterSprite: charSprite,
    lureImages: {
        lureImg,
        superLureImg,
        ultraLureImg
      },
    width: 1120,
    height: 1120,
    tileSize: 8,
    viewport: { width: 336, height: 240 },
    initialPlayer: { x: 500, y: 500, direction: "down", step: 0 },
    collisionAreas: [],
  },
  communityLowvis: {
    id: 16,
    image: lowVisImg,
    characterSprite: charSprite,
    lureImages: {
        lureImg,
        superLureImg,
        ultraLureImg
      },
    width: 1120,
    height: 1120,
    tileSize: 8,
    viewport: { width: 336, height: 240 },
    initialPlayer: { x: 500, y: 500, direction: "down", step: 0 },
    collisionAreas: [],
  },
  treasure: {
    id: 21,
    image: treasureImg,
    battleBackground: "/Battle/BeachBG.png",
    characterSprite: charSprite,
    lureImages: {
        lureImg,
        superLureImg,
        ultraLureImg
      },
    width: 383,
    height: 639,
    tileSize: 8,
    viewport: { width: 336, height: 240 },
    initialPlayer: { x: 148, y: 308, direction: "down", step: 0 },
    collisionAreas: [
      { x: 128, y: 276, width: 60, height: 1,  "padX": 6, "padY": 12},
      { x: 200, y: 295, width: 60, height: 1,  "padX": 6, "padY": 12},
      { x: 208, y: 268, width: 1, height: 1,},
      { x: 262, y: 300, width: 1, height: 1,  "padX": 6, "padY": 12},
      { x: 264, y: 310, width: 30, height: 1,  "padX": 6, "padY": 12},
      { x: 294, y: 310, width: 1, height: 30,  "padX": 6, "padY": 12},
      { x: 292, y: 340, width: 30, height: 1,  "padX": 6, "padY": 12},
      { x: 328, y: 340, width: 1, height: 30,  "padX": 6, "padY": 12},

      { x: 300, y: 376, width: 30, height: 1,  "padX": 6, "padY": 12},
      { x: 200, y: 274, width: 1, height: 20,  "padX": 6, "padY": 12},
      { x: 118, y: 266, width: 1, height: 30,  "padX": 6, "padY": 12},
      { x: 92, y: 290, width: 30, height: 1,  "padX": 6, "padY": 12},
      { x: 88, y: 290, width: 1, height: 20,  "padX": 6, "padY": 12},
      { x: 70, y: 315, width: 1, height: 35,  "padX": 6, "padY": 12},
      { x: 70, y: 310, width:10, height: 1,  "padX": 6, "padY": 12},
      { x: 55, y: 350, width: 1, height: 45,  "padX": 6, "padY": 12},
      { x: 40, y: 400, width: 1, height: 55,  "padX": 6, "padY": 12},

      { x: 284, y: 430, width: 8, height: 2,  "padX": 6, "padY": 12},
      { x: 298, y: 385, width: 1, height: 45,  "padX": 6, "padY": 12},
      { x: 282, y: 435, width: 1, height: 120,  "padX": 6, "padY": 12},

      { x: 217, y: 540, width: 80, height: 1,  "padX": 6, "padY": 12},
      { x: 217, y: 540, width: 1, height: 8,  "padX": 6, "padY": 12},
      { x: 147, y: 555, width:70, height: 1,  "padX": 6, "padY": 12},
      { x: 140, y: 550, width: 1, height: 8,  "padX": 6, "padY": 12},
      { x: 50, y: 540, width: 80, height: 1,  "padX": 6, "padY": 12},
      { x: 105, y: 473, width: 1, height: 65,  "padX": 6, "padY": 12},
      { x: 42, y: 463, width: 60, height: 1,  "padX": 6, "padY": 12},
    ],
  },
  ice: {
    id: 23,
    image: iceImg,
    battleBackground: "/Battle/IceBG.png",
    characterSprite: charSprite,
    lureImages: {
        lureImg,
        superLureImg,
        ultraLureImg
      },
    width: 560,
    height: 496,
    tileSize: 8,
    viewport: { width: 336, height: 240 },
    initialPlayer: { x: 148, y: 308, direction: "down", step: 0 },
    collisionAreas: [
      { x: 36, y: 250, width: 1, height: 230,  "padX": 6, "padY": 12},
      { x: 168, y: 375, width: 1, height: 105,  "padX": 6, "padY": 12},
      { x: 170, y: 370, width: 130, height: 1,  "padX": 6, "padY": 12},
      { x: 311, y: 370, width: 1, height: 100,  "padX": 6, "padY": 12},
      { x: 308, y: 446, width: 55, height: 1,  "padX": 6, "padY": 12},
      { x: 364, y: 444, width: 1, height: 40,  "padX": 6, "padY": 12},
      { x: 540, y: 130, width: 1, height: 350,  "padX": 6, "padY": 12},
      { x: 170, y: 20, width: 370, height: 1,  "padX": 6, "padY": 12},
      { x: 540, y: 24, width: 1, height: 60,  "padX": 6, "padY": 12},
      { x: 492, y: 128, width: 1, height: 30,  "padX": 6, "padY": 12},

      { x: 496, y: 130, width: 30, height: 1,  "padX": 6, "padY": 12},
      { x: 496, y: 160, width: 30, height: 1,  "padX": 6, "padY": 12},


      { x: 170, y: 16, width: 1, height: 225,  "padX": 6, "padY": 12},
      { x: 114, y: 242, width: 80, height: 1,  "padX": 6, "padY": 12},
      { x: 22, y: 242, width: 40, height: 1,  "padX": 6, "padY": 12},


      { x: 192, y: 200, width: 40, height: 40,  "padX": 6, "padY": 12},
      { x: 255, y: 215, width: 5, height: 30,  "padX": 6, "padY": 12},
      { x: 184, y: 144, width: 30, height: 30,  "padX": 6, "padY": 12},
    ],
  },
  rusturfTunnel: {
    id: 11,
    image: rusturfTunnelImg,
    characterSprite: charSprite,
    lureImages: {
        lureImg,
        superLureImg,
        ultraLureImg
      },
    width: 576,
    height: 384,
    tileSize: 8,
    viewport: { width: 336, height: 240 },
    initialPlayer: { x: 278, y: 302, direction: "up", step: 0 },
    collisionAreas: [
      { x: 152, y: 38, width: 280, height: 20,  "padX": 6, "padY": 12},
      // { x: 246, y: 325, width: 108, height: 9,  "padX": 6, "padY": 12},
      { x: 220, y: 270, width: 50, height: 80,  "padX": 6, "padY": 12},
      { x: 235, y: 210, width: 50, height: 80,  "padX": 6, "padY": 12},
      { x: 323, y: 314, width: 10, height: 25,  "padX": 6, "padY": 12},
      { x: 323, y: 230, width: 8, height: 25,  "padX": 6, "padY": 12},
      { x: 289, y: 211, width: 55, height: 20,  "padX": 6, "padY": 12},
      { x: 340, y: 308, width: 280, height: 80,  "padX": 6, "padY": 12},
      { x: 356, y: 269, width: 275, height: 44,  "padX": 6, "padY": 12},
      { x: 355, y: 195, width: 10, height: 25,  "padX": 6, "padY": 12},

      
      { x: 360, y: 255, width: 8, height: 25,  "padX": 6, "padY": 12},
      { x: 340, y: 178, width: 115, height: 30,  "padX": 6, "padY": 12},
      { x: 420, y: 195, width: 10, height: 25,  "padX": 6, "padY": 12},
      { x: 518, y: 227, width: 50, height: 60,  "padX": 6, "padY": 12},
      { x: 527, y: 170, width: 50, height: 60,  "padX": 6, "padY": 12},
      { x: 547, y: 110, width: 50, height: 60,  "padX": 6, "padY": 12},
      { x: 547, y: 50, width: 50, height: 60,  "padX": 6, "padY": 12},
      { x: 500, y: 45, width: 50, height: 40,  "padX": 6, "padY": 12},
      { x: 525, y: 90, width: 20, height: 15,  "padX": 6, "padY": 12},
      { x: 520, y: -10, width: 58, height: 60,  "padX": 6, "padY": 12},
      { x: 440, y: -28, width: 80, height: 60,  "padX": 6, "padY": 12},
      { x: 494, y: -10, width: 80, height: 60,  "padX": 6, "padY": 12},
      { x: 370, y: -2, width: 80, height: 60,  "padX": 6, "padY": 12},
      
      { x: 152, y: 1, width: 300, height: 20,  "padX": 6, "padY": 12},
      { x: 152, y: 20, width: 300, height: 20,  "padX": 6, "padY": 12},
      { x: 24, y: 20, width: 25, height: 200,  "padX": 6, "padY": 12},
      { x: 24, y: 2, width: 25, height: 20,  "padX": 6, "padY": 12},
      { x: 49, y: 48, width: 72, height: 17,  "padX": 6, "padY": 12},
      { x: 86, y: 96, width: 60, height: 17,  "padX": 6, "padY": 12},
      { x: 150, y: 93, width: 289, height: 110,  "padX": 6, "padY": 12},
      { x: 0, y: 352, width: 360, height: 30,  "padX": 6, "padY": 12},
      { x: 0, y: 325, width: 250, height: 30,  "padX": 6, "padY": 12},
      { x: 0, y: 298, width: 250, height: 30,  "padX": 6, "padY": 12},
      { x: 0, y: 270, width: 250, height: 30,  "padX": 6, "padY": 12},
      { x: 487, y: 160, width: 55, height: 20,  "padX": 6, "padY": 12},
      { x: 48, y: 176, width: 150, height: 80,  "padX": 6, "padY": 12},
      { x: 130, y: 96, width: 60, height: 80,  "padX": 6, "padY": 12},
      { x: 120, y: 160, width: 15, height: 20,  "padX": 6, "padY": 12},
      { x: 256, y: 335, width: 90, height: 20,  "padX": 6, "padY": 12},
      { x: 440, y: 160, width: 15, height: 20,  "padX": 6, "padY": 12},
      { x: 530, y: 110, width: 20, height: 20,  "padX": 6, "padY": 12},

      
      
      // { x: 262, y: 288, width: 8, height: 40,  "padX": 6, "padY": 12},
      // { x: 280, y: 210, width: 8, height: 50,  "padX": 6, "padY": 12},
    ],
  },
  emberspa: {
    id: 12,
    image: emberspaImg,
    characterSprite: charSprite,
    lureImages: {
        lureImg,
        superLureImg,
        ultraLureImg
      },
    width: 431,
    height: 623,
    tileSize: 8,
    viewport: { width: 336, height: 240 },
    initialPlayer: { x: 200, y: 544, direction: "up", step: 0 },
    collisionAreas: [
      { x: 148, y: 430, width: 50, height: 200,  "padX": 6, "padY": 12},
      { x: 192, y: 594, width: 50, height: 200,  "padX": 6, "padY": 12},
      { x: 148, y: 418, width: 50, height: 156,  "padX": 6, "padY": 12},
      { x: 130, y: 354, width: 50, height: 156,  "padX": 6, "padY": 12},
      { x: 98, y: 354, width: 50, height: 156,  "padX": 6, "padY": 12},
      { x: 67, y: 337, width: 50, height: 156,  "padX": 6, "padY": 12},
      { x: 238, y: 446, width: 50, height: 156,  "padX": 6, "padY": 12},
      { x: 250, y: 353, width: 50, height: 156,  "padX": 6, "padY": 12},
      { x: 301, y: 338, width: 50, height: 156,  "padX": 6, "padY": 12},
      { x: 350, y: 338, width: 50, height: 156,  "padX": 6, "padY": 12},
      { x: 380, y: 338, width: 50, height: 156,  "padX": 6, "padY": 12},
      { x: 380, y: 186, width: 50, height: 156,  "padX": 6, "padY": 12},
      { x: 360, y: 186, width: 50, height: 156,  "padX": 6, "padY": 12},
      { x: 360, y: 159, width: 50, height: 156,  "padX": 6, "padY": 12},
      { x: 395, y: 109, width: 50, height: 156,  "padX": 6, "padY": 12},
      { x: 395, y: 70, width: 50, height: 156,  "padX": 6, "padY": 12},
      { x: 395, y: 70, width: 50, height: 156,  "padX": 6, "padY": 12},
      { x: 395, y: .1, width: 50, height: 156,  "padX": 6, "padY": 12},
      { x: 375, y: .1, width: 50, height: 98,  "padX": 6, "padY": 12},
      { x: 340, y: .1, width: 50, height: 98,  "padX": 6, "padY": 12},
      { x: 320, y: .1, width: 50, height: 98,  "padX": 6, "padY": 12},
      { x: 280, y: .1, width: 50, height: 98,  "padX": 6, "padY": 12},
      
      { x: 240, y: .1, width: 50, height: 98,  "padX": 6, "padY": 12},
      
      { x: 184, y: 60, width: 117, height: 67,  "padX": 6, "padY": 12},
      { x: 184, y: -1, width: 117, height: 67,  "padX": 6, "padY": 12},
      { x: 120, y: -1, width: 117, height: 67,  "padX": 6, "padY": 12},
      { x: 40, y: -1, width: 117, height: 67,  "padX": 6, "padY": 12},
      { x: 40, y: 64, width: 117, height: 50,  "padX": 6, "padY": 12},
      { x: 40, y: 176, width: 117, height: 50,  "padX": 6, "padY": 12},
      { x: 40, y: 190, width: 117, height: 50,  "padX": 6, "padY": 12},
      { x: 40, y: 208, width: 117, height: 50,  "padX": 6, "padY": 12},
      { x: -2, y: 2, width: 50, height: 190,  "padX": 6, "padY": 12},
      { x: 25, y: 119, width: 50, height: 190,  "padX": 6, "padY": 12},
      { x: 22, y: 230, width: 50, height: 190,  "padX": 6, "padY": 12},
      { x: 115, y: 160, width: 50, height: 60,  "padX": 6, "padY": 12},
      { x: 270, y: 160, width: 60, height: 60,  "padX": 6, "padY": 12},
      
      { x: 270, y: 220, width: 40, height: 60,  "padX": 6, "padY": 12},
      { x: 155, y: 160, width: 50, height: 15,  "padX": 6, "padY": 12},
      { x: 230, y: 160, width: 50, height: 15,  "padX": 6, "padY": 12},
      { x: 128, y: 240, width: 187, height: 38,  "padX": 6, "padY": 12},
      { x: 128, y: 250, width: 187, height: 38,  "padX": 6, "padY": 12},
     
    ],
  },
  route25: {
    id: 23,
    image: route25Img,
    characterSprite: charSprite,
    lureImages: {
        lureImg,
        superLureImg,
        ultraLureImg
      },
    width: 1149,
    height: 317,
    tileSize: 8,
    viewport: { width: 336, height: 240 },
    initialPlayer: { x: 148, y: 308, direction: "down", step: 0 },
    collisionAreas: [

    ],
  },
  safari: {
    id: 10,
    image: safariImg,
    over: safariOverImg,
    characterSprite: charSprite,
    lureImages: {
        lureImg,
        superLureImg,
        ultraLureImg
      },
    width: 655,
    height: 476,
    tileSize: 8,
    viewport: { width: 336, height: 240 },
    initialPlayer: { x: 300, y: 300, direction: "down", step: 0 },
    collisionAreas: [
        { x: 100, y: 80, width: 400, height: 32 }, // Example wall 1
        { x: 100, y: 90, width: 10, height: 400 }, // Example wall 1
        { x: 510, y: 90, width: 10, height: 400 }, // Example wall 1
        { x: 400, y: 310, width: 60, height: 20 }, // Example wall 1
        { x: 400, y: 265, width: 60, height: 5 }, // Example wall 1
        { x: 400, y: 190, width: 60, height: 5 }, // Example wall 1
        { x: 172, y: 180, width: 68, height: 40 },
        { x: 270, y: 255, width: 4, height: 4 },
        { x: 350, y: 125, width: 62, height: 4 },
        { x: 167, y: 300, width: 40, height: 25 },
        { x: 117, y: 420, width: 108, height: 25 },
        { x: 395, y: 420, width: 108, height: 25 },
        { x: 130, y: 110, width: 32, height: 32 },
        { x: 450, y: 380, width: 3, height: 2 },
        { x: 255, y: 370, width: 3, height: 2 },
    ],
  },
  ruin: {
    id: 20,
    image: ruinImg,
    characterSprite: charSprite,
    lureImages: {
        lureImg,
        superLureImg,
        ultraLureImg
      },
    width: 768,
    height: 640,
    tileSize: 8,
    viewport: { width: 336, height: 240 },
    initialPlayer: { x: 380, y: 436, direction: "down", step: 0 },
    collisionAreas: [
      { x: 423, y: 436, width: 1, height: 45 },
      { x: 475, y: 280, width: 1, height: 140},
      { x: 316, y: 280, width: 1, height: 100},
      { x: 360, y: 443, width: 1, height: 50},
      { x: 268, y: 356, width: 18, height: 50},
      { x: 304, y: 404, width: 1, height: 10},
      { x: 67, y: 532, width: 1, height: 10},
      { x: 140, y: 410, width: 1, height: 140},
      { x: 160, y: 410, width: 1, height: 140},
      { x: 180, y: 510, width: 1, height: 50},
      { x: 300, y: 510, width: 1, height: 50},
      { x: 300, y: 500, width: 50, height: 1},
      { x: 354, y: 508, width: 2, height: 2 },
      { x: 354, y: 516, width: 2, height: 2 },
      // { x: 300, y: 212, width: 2, height: 2 },
      { x: 215, y: 213, width: 1, height: 225,  "padX": 6, "padY": 12},
      { x: 232, y: 470, width: 1, height: 30},

      { x: 184, y: 306, width: 30, height: 1,  "padX": 6, "padY": 6},
      { x: 483, y: 485, width: 100, height: 1 },

      { x: 565, y: 420, width: 25, height: 1,  "padX": 6, "padY": 6},

      { x: 500, y: 420, width: 25, height: 1,  "padX": 6, "padY": 6},


      { x: 608, y: 480, width: 16, height: 16, "padX": 10, "padY": 12 },


      { x: 624, y: 365, width: 16, height: 16, "padX": 8, "padY": 12 },


      { x: 560, y: 350, width: 16, height: 16, "padX": 8, "padY": 12 },

      { x: 495, y: 350, width: 16, height: 16, "padX": 8, "padY": 12 },


      { x: 528, y: 320, width: 16, height: 16, "padX": 8, "padY": 12 },

      { x: 548, y: 288, width: 16, height: 16, "padX": 8, "padY": 12 },

      { x: 548, y: 224, width: 16, height: 16, "padX": 8, "padY": 12 },

      { x: 495, y: 257, width: 16, height: 16, "padX": 8, "padY": 12 },

      { x: 528, y: 175, width: 16, height: 16, "padX": 8, "padY": 12 },
      { x: 224, y: 195, width: 16, height: 16, "padX": 8, "padY": 12 },

      { x: 272, y: 173, width: 16, height: 16, "padX": 12, "padY": 16 },

      { x: 200, y: 213, width: 50, height: 1},

      { x: 159, y: 158, width: 16, height: 16, "padX": 12, "padY": 16 },

      { x: 595, y: 295, width: 1, height: 180 },


      { x: 654, y: 496, width: 16, height: 16, "padX": 8, "padY": 12 },
      
      { x: 594, y: 526, width: 16, height: 16, "padX": 8, "padY": 12 },

  

      { x: 230, y: 230, width: 24, height: 60},
      { x: 335, y: 150, width: 95, height: 60},

      
      { x: 240, y: 496, width: 10, height: 1},
      { x: 372, y: 332, width: 50, height: 50},
      { x: 322, y: 382, width: 150, height: 1},

      { x: 78, y: 80, width: 1, height: 100},
      { x: 78, y: 88, width: 120, height: 1},
      { x: 152, y: 78, width: 120, height: 1},
      { x: 302, y: 60, width: 240, height: 1},
      // right here
      { x: 250, y: 210, width: 80, height: 1, "padX": 6, "padY": 6},
      { x: 540, y: 80, width: 220, height: 1},
      { x: 620, y: 95, width: 60, height: 1},
      { x: 690, y:120, width: 65, height: 1},


      { x: 690, y:220, width: 65, height: 1},


      { x: 670, y:250, width: 1, height: 225},
      { x: 655, y:380, width: 1, height: 80},

      { x: 590, y:570, width: 140, height:80},

      { x: 590, y:550, width:40, height:10},


      { x: 300, y:550, width:120, height:10},

      { x: 400, y:595, width:200, height:10},

      { x: 715, y:550, width:40, height:10},

      { x: 715, y:500, width:10, height:40},


      { x: 700, y:490, width:40, height:10},

      { x: 705, y:550, width:1, height:1},

      { x: 306, y: 269, width: 175, height: 1, "padX": 12, "padY": 12},

      { x: 491, y: 205, width: 1, height: 215, "padX": 12, "padY": 12},


      { x: 146, y: 159, width: 175, height: 1, "padX": 12, "padY": 12},
      { x: 130, y: 164, width: 12, height: 140, "padX": 12, "padY": 12},

      { x: 452, y: 159, width: 103, height: 1, "padX": 12, "padY": 12},
      { x: 562, y: 163, width: 20, height: 140, "padX": 12, "padY": 12},

      { x: 122, y: 403, width: 1, height: 1},
      { x: 102, y: 451, width: 1, height: 1},
      { x: 82, y: 371, width: 1, height: 140},
      { x: 62, y: 171, width: 1, height: 240},
      { x: 72, y: 567, width: 340, height: 1},
    ]
  },

  gamesCorner: {
    id: 0,
    image: gamesCornerImg,
    characterSprite: charSprite,
    lureImages: {
      lureImg,
      superLureImg,
      ultraLureImg
    },
    width: 292,
    height: 244,
    tileSize: 8,
    viewport: { width: 336, height: 240 },
    initialPlayer: { x: 140, y: 180, direction: "up", step: 0 },
    collisionAreas: [
      { x: 0, y: 0, width: 292, height: 8 },
      { x: 0, y: 236, width: 292, height: 8 },
      { x: 0, y: 0, width: 8, height: 244 },
      { x: 284, y: 0, width: 8, height: 244 },
      { x: 30, y: 31, width: 130, height: 25, "padX": 12, "padY": 12},
      { x: 84, y: 90, width: 25, height: 85, "padX": 12, "padY": 12},
      { x: 180, y: 90, width: 25, height: 85, "padX": 12, "padY": 12},
      { x: 227, y: 56, width: 48, height: 15, "padX": 12, "padY": 12},
    ],
    npcs: [
      {
        id: "TicketOfficer",
        x:  70,
        y: 25,
        width:  16,
        height: 24,
        sprite: "/Trainers/store-owner.png",
        modalType: "ticket-exchange",
        name: "Ticket Officer"
      },
      {
        id: "RaffleOfficer",
        x:  17,
        y: 100,
        width:  16,
        height: 24,
        sprite: "/Trainers/raffle.png",
        modalType: "raffle",
        name: "Raffle Officer"
      },
      {
        id: "CollectionContestOfficer",
        x:  95,
        y: 25,
        width:  16,
        height: 24,
        sprite: "/Trainers/collection-contest.png",
        modalType: "collection-contest",
        name: "Collection Contest Officer"
      },
      {
        id: "luckyDipOfficer",
        x:  112,
        y: 85,
        width:  16,
        height: 24,
        sprite: "/Trainers/lucky-dip.png",
        modalType: "luckyDip",
        name: "Lucky Dip Officer"
      },
      {
        id: "auctionhouse",
        x:  165,
        y: 115,
        width:  16,
        height: 24,
        sprite: "/Trainers/auction-house.png",
        modalType: "auctionhouse",
        name: "Auction House Officer"
      },
      {
        id: "ballon-pop",
        x:  68,
        y: 115,
        width:  16,
        height: 24,
        sprite: "/Trainers/seviper.png",
        modalType: "ballon-pop",
        name: "Ballon Pop Officer"
      },
      {
        id: "racetrack",
        x:  209,
        y: 118,
        width:  16,
        height: 24,
        sprite: "/Trainers/race-track.png",
        modalType: "racetrack",
        name: "Race Track Officer"
      },
      {
        id: "diglettdash",
        x:  15,
        y: 150,
        width:  16,
        height: 24,
        sprite: "/Trainers/miner-left.png",
        modalType: "diglettdash",
        name: "Diglett Dash Officer"
      }
   //   {
  //      id: "wheeloffurtune",
 //       x:  209,
  //      y: 138,
   ////     width:  16,
   //     height: 24,
   //     sprite: "/Trainers/race-track.png",
   //     modalType: "wheeloffortune",
   //     name: "Wheel of Fortune Officer"
    //  }
    ],
  },


  playerShop: {
    id: 'playerShop',
    image: player_shopImg,
    characterSprite: charSprite,
    lureImages: {
      lureImg,
      superLureImg,
      ultraLureImg
    },
    pokemon: [], // Add empty pokemon array to prevent warnings
    width: 800,
    height: 560,
    tileSize: 8,
    viewport: { width: 336, height: 240 },
    initialPlayer: { x: 140, y: 260, direction: "left", step: 0 },
    collisionAreas: [
      { x: 40, y: 0, width: 45, height: 40 },
      { x: 140, y: 0, width: 40, height: 40 },
      { x: 235, y: 0, width: 45, height: 40 },
      { x: 330, y: 0, width: 45, height: 40 },
      { x: 425, y: 0, width: 45, height: 40 },

      { x: 510, y: 0, width: 5, height: 200 },

      { x: 510, y: 300, width: 5, height: 275 },

      { x: 40, y: 117, width: 45, height: 33 },
      { x: 137, y: 117, width: 45, height: 33 },
      { x: 235, y: 117, width: 45, height: 33 },
      { x: 331, y: 117, width: 45, height: 33 },
      { x: 425, y: 117, width: 45, height: 33 },
      { x: 425, y: 342, width: 45, height: 33 },
      { x: 331, y: 342, width: 45, height: 33 },
      { x: 235, y: 342, width: 45, height: 33 },
      { x: 137, y: 342, width: 45, height: 33 },
      { x: 40, y: 342, width: 45, height: 33 },
      { x: 425, y: 452, width: 45, height: 33 },
      { x: 331, y: 452, width: 45, height: 33 },
      { x: 235, y: 452, width: 45, height: 33 },
      { x: 137, y: 452, width: 45, height: 33 },
      { x: 40, y: 452, width: 45, height: 33 },


      { x: 510, y: 300, width: 200, height: 5 },
      { x: 510, y: 200, width: 200, height: 5 },
      { x: 730, y: 200, width: 80, height: 100 },
    ],
    npcs: [
      {
        id: "Realtor",
        x:  20,
        y: 244,
        width:  16,
        height: 24,
        sprite: "/Trainers/realtor.png",
        name: "Realtor",
        dialogue: "Welcome to the Player Shop District! I manage all the shop lots in this area. Would you like to rent a lot to sell your items? Lots are available for 1-6 months at a rate of 20 coins per day.",
        buttonText: "View Available Lots",
        modalType: "playerShopLot"
      },
      // Shop lots will be dynamically added here from the API
    ],
    // Function to dynamically add shop lots as NPCs
    onMapLoad: (mapConfig, setMapConfig) => {
      // Fetch shop lots from API
      const fetchShopLots = async () => {
        try {
          const response = await fetch('/v1/player-shops/available-lots', {
            credentials: 'include'
          });
          
          if (!response.ok) {
            console.error('Failed to fetch shop lots');
            return;
          }
          
          const lotsData = await response.json();
          
          // Also fetch rented lots to show player shops
          const rentedResponse = await fetch('/v1/player-shops/my-lots', {
            credentials: 'include'
          });
          
          let rentedLots = [];
          if (rentedResponse.ok) {
            rentedLots = await rentedResponse.json();
          }
          
          // Combine all lots
          const allLots = [...lotsData, ...rentedLots];
          
          // Create NPCs for each lot
          const lotNpcs = allLots.map(lot => ({
            id: `ShopLot_${lot.id}`,
            x: lot.x_position,
            y: lot.y_position,
            width: 16,
            height: 24,
            sprite: lot.owner_id ? "/Trainers/shop-owner.png" : "/Trainers/shop-empty.png",
            name: lot.owner_id ? `${lot.owner_username}'s Shop` : `Lot #${lot.lot_number}`,
            modalType: lot.owner_id ? "playerShopBrowse" : "playerShopLot",
            lotId: lot.id,
            ownerId: lot.owner_id,
            status: lot.status
          }));
          
          // Update map config with the new NPCs
          const updatedNpcs = [...mapConfig.npcs.filter(npc => npc.id === "Realtor"), ...lotNpcs];
          setMapConfig({
            ...mapConfig,
            npcs: updatedNpcs
          });
          
        } catch (error) {
          console.error('Error fetching shop lots:', error);
        }
      };
      
      fetchShopLots();
    }
  },
  
  departmentStore1: {
    id: 'dept-store-1',
    image: deptStore1Img,
    characterSprite: charSprite,
    width: 207,
    height: 256,
    tileSize: 8,
    viewport: { width: 336, height: 240 },
    initialPlayer: { x: 100, y: 200, direction: "up", step: 0 },
    collisionAreas: [
      { x: 100, y: 135, width: 45, height: 40},
      { x: 60, y: 135, width: 45, height: 40},
      { x: 0, y: 250, width: 200, height: 1},
       { x: 217, y: 70, width: 1, height: 200},
       { x: -12, y: 70, width: 1, height: 200},
       { x: 200, y: 202, width: 5, height: 2},
       { x: 0, y: 200, width: 5, height: 5},
        { x: 0, y: 110, width: 5, height: 5},
        { x: 0, y: 60, width: 50, height: 5},
        { x: 25, y: 10, width: 1000, height: 5},
        { x: 170, y: 16, width: 5, height: 45},
        { x: 182, y: 75, width: 5, height: 5},
        { x: 10, y: 10, width: 5, height: 25},
    ],
    teleportZones: [
      // Stairs to floor 2 - increased size for better detection
      { x: 36, y: 16, width: 3, height: 3, targetFloor: 'departmentStore2', targetX: 48, targetY: 50 }
    ],
     // ← NEW: your trainer NPC, positioned at (88,144), size 16×24
    npcs: [
      {
        id: "StoreOwner",
        x:  80,
        y: 144,
        width:  16,
        height: 24,
        sprite: "/Trainers/store-owner.png"
      },
      {
        id: "Miner",
        x:  116,
        y: 144,
        width:  16,
        height: 24,
        sprite: "/Trainers/miner.png",
        type: "mining"
      },
      {
        id: "Elevator1",
        x: 95,
        y: 20,
        width: 16,
        height: 24,
        sprite: "/Trainers/store-owner.png",
        type: "elevator",
        currentFloor: 1
      },
    ],

    isIndoor: true,
    floorNumber: 1
  },
  
  departmentStore2: {
    id: 'dept-store-2',
    image: deptStore2Img,
    characterSprite: charSprite,
    width: 208,
    height: 240,
    tileSize: 8,
    viewport: { width: 336, height: 240 },
    initialPlayer: { x: 96, y: 50, direction: "down", step: 0 },
    collisionAreas: [
      { x: 120, y: 130, width: 15, height: 20},
       { x: 168, y: 130, width: 15, height: 20},
       { x: 168, y: 190, width: 15, height: 30},
       { x: 121, y: 190, width: 15, height: 30},
      { x: 0, y: 90, width: 40, height: 50},
       { x: 0, y: 260, width:300, height: 10},
       { x: 30, y: 175, width:25, height: 3},
       { x: 30, y: 205, width:25, height: 3},
       { x: -35, y: 142, width:25, height: 200},
       { x: 216, y: 58, width:25, height: 200},
       { x: 0, y: 0, width:200, height: 10},
       { x: 205, y: 0, width:10, height: 30},
       { x: 168, y: 46, width:30, height: 30},
        { x: 0, y: 56, width:40, height: 10},
    ],
    teleportZones: [
      // Stairs to floor 1 - increased size for better detection
      { x: 136, y: 11, width: 5, height: 5, targetFloor: 'departmentStore3', targetX: 116, targetY: 48 },
      { x: 36, y: 22, width: 1, height: 1, targetFloor: 'departmentStore1', targetX: 40, targetY: 24 }
    ],
    npcs: [
      {
        id: "PotionTrainerOwner",
        x: 15,
        y: 114,
        width:  16,
        height: 24,
        sprite: "/Trainers/trainer-owner.png",
        type: "trainer-potion"
      },
      
      {
        id: "Trainer2Owner",
        x: 15,
        y: 80,
        width:  16,
        height: 24,
        sprite: "/Trainers/trainer-owner-2.png",
        type: "trainer-ev"
      },
      {
        id: "Elevator2",
        x: 95,
        y: 20,
        width: 16,
        height: 24,
        sprite: "/Trainers/store-owner.png",
        type: "elevator",
        currentFloor: 2
      },
    ],
    isIndoor: true,
    floorNumber: 2
  },
  departmentStore3: {
    id: 'dept-store-3',
    image: deptStore3Img,
    characterSprite: charSprite,
    width: 208,
    height: 240,
    tileSize: 8,
    viewport: { width: 336, height: 240 },
    initialPlayer: { x: 96, y: 50, direction: "down", step: 0 },
    collisionAreas: [
      { x: 140, y: 130, width: 55, height: 45},

      { x: 0, y: 130, width: 100, height: 1},
      { x: 0, y:175, width: 100, height: 1},
      { x: 0, y:240, width: 200, height: 1},

      { x: 218, y:10, width: 1, height: 300},
      { x: -15, y:10, width: 1, height: 300},
      { x: 0, y:10, width: 300, height: 1},
      { x: 20, y:24, width: 5, height: 5},


      { x: 10, y:60, width: 30, height: 10},
      { x: 175, y:60, width: 30, height: 10},
      { x: 185, y:80, width: 30, height: 10},
      { x: 204, y:215, width: 1, height: 3},
      { x: 4, y:215, width: 1, height: 3},
    ],
    teleportZones: [
      { x: 168, y: 20, width: 1, height: 1, targetFloor: 'departmentStore2', targetX: 140, targetY: 16 }
    ],
    npcs: [
       {
        id: "TMTrainer",
        x: 160,
        y: 130,
        width:  16,
        height: 24,
        sprite: "/Trainers/tm-trainer.png",
        type: "tm-trainer"
      },
      {
        id: "Elevator3",
        x: 95,
        y: 20,
        width: 16,
        height: 24,
        sprite: "/Trainers/store-owner.png",
        type: "elevator",
        currentFloor: 3
      },
    ],
    isIndoor: true,
    floorNumber: 3
  },
  promoCenter: {
    id: 'promo-center',
    image: promoCenterImg,
    characterSprite: charSprite,
    width: 144,
    height: 159,
    tileSize: 8,
    viewport: { width: 336, height: 240 },
    initialPlayer: { x: 55, y: 100, direction: "up", step: 0 },
    collisionAreas: [
     
      { x:0, y: 30, width: 130, height: 8 },  
      { x: 0, y: 0, width: 144, height: 8 },      // Top wall
      { x: 0, y: 151, width: 144, height: 8 },    // Bottom wall (within map bounds)

      { x:122, y: 88, width: 10, height: 8 },    
      { x:8, y: 88, width: 10, height: 8 },  
      { x: -18, y: 0, width: 8, height: 159 },      // Left wall
      { x: 156, y: 0, width: 8, height: 159 },    // Right wall
    ],
    teleportZones: [

    ],
    npcs: [
      {
        id: "PromoHost",
        x: 97,
        y: 20,
        width: 16,
        height: 24,
        sprite: "/Trainers/promo-center-trainer.png",
        type: "promo"
      },
      {
        id: "CraftHost",
        x: 33,
        y: 20,
        width: 16,
        height: 24,
        sprite: "/Trainers/miner.png",
        type: "craft"
      },
    //  {
    //    id: "Magma-Girl",
    //    x: 63,
    //    y: 20,
    //    width: 16,
    //    height: 24,
    //    sprite: "/Trainers/Magma.png",
    //    type: "event"
    //  },
    ],
    isIndoor: true,
    floorNumber: 1
 },
  battleTower1: {
    battleBackground: "/Battle/CaveBG.png",
    image: magmaTower1Img,
    characterSprite: charSprite,
    lureImages: {
      lureImg,
      superLureImg,
      ultraLureImg
    },
    width: 368,
    height: 368,
    tileSize: 8,
    viewport: { width: 336, height: 240 },
    initialPlayer: { x: 128, y: 220, direction: "up", step: 0 },
    collisionAreas: [
      { x: 76, y: 76, width: 1, height: 245,  "padX": 6, "padY": 12},
      { x: 60, y: 285, width: 225, height: 1,  "padX": 6, "padY": 12},
      { x: 60, y: 70, width: 225, height: 1,  "padX": 6, "padY": 12},
      { x: 55, y: 75, width: 80, height: 12,  "padX": 6, "padY": 12},
      { x: 150, y: 150, width: 80, height: 1,  "padX": 6, "padY": 12},
      { x: 170, y: 120, width: 80, height: 1,  "padX": 6, "padY": 12},
      { x: 170, y: 135, width: 80, height: 5,  "padX": 6, "padY": 12},
      { x: 137, y: 155, width: 180, height: 55,  "padX": 6, "padY": 12},
      { x: 167, y: 205, width: 60, height: 25,  "padX": 6, "padY": 12},
      { x: 39, y: 270, width: 60, height: 25,  "padX": 6, "padY": 12},
      { x: 270, y: 270, width: 60, height: 25,  "padX": 6, "padY": 12},
      { x: 295, y: 220, width: 60, height: 50,  "padX": 6, "padY": 12},
      { x: 275, y: 70, width: 60, height: 50,  "padX": 6, "padY": 12},
      { x: 225, y: 110, width: 60, height: 50,  "padX": 6, "padY": 12},
    ],
    npcs: [
      {
        id: "MagmaGrunt1",
        x: 210,
        y: 100,
        width: 16,
        height: 24,
        sprite: "/Trainers/team-magma-grunt.png",
        type: "grunt"
      }
    ],
    isIndoor: true,
    floorNumber: 1
  },
  battleTower2: {
    showSteamEffects: true,
    steamPoints: [
      { x: 180, y: 180 }, { x: 200, y: 185 }, { x: 220, y: 175 }, { x: 240, y: 180 },
      { x: 280, y: 190 }, { x: 300, y: 185 }, { x: 320, y: 195 },
      { x: 190, y: 140 }, { x: 250, y: 145 }, { x: 310, y: 150 },
      { x: 170, y: 220 }, { x: 210, y: 225 }, { x: 270, y: 230 }, { x: 320, y: 235 }
    ],
    battleBackground: "/Battle/FireCave.png",
    image: magmaTower2Img,
    characterSprite: charSprite,
    lureImages: {
      lureImg,
      superLureImg,
      ultraLureImg
    },
    width: 368,
    height: 368,
    tileSize: 8,
    viewport: { width: 336, height: 240 },
    initialPlayer: { x: 72, y: 180, direction: "down", step: 0 },
    collisionAreas: [
      { x: 66, y: 76, width: 1, height: 245,  "padX": 6, "padY": 12},
      { x: 60, y: 285, width: 225, height: 1,  "padX": 6, "padY": 12},
      { x: 60, y: 70, width: 225, height: 1,  "padX": 6, "padY": 12},
      { x: 55, y: 75, width: 80, height: 50,  "padX": 6, "padY": 12},

      { x: 120, y: 155, width: 95, height: 80,  "padX": 6, "padY": 12},


      { x: 100, y: 135, width: 85, height: 20,  "padX": 6, "padY": 12},
      { x: 100, y: 125, width: 85, height: 20,  "padX": 6, "padY": 12},

      { x: 80, y: 155, width: 85, height: 20,  "padX": 6, "padY": 12},


      { x: 39, y: 270, width: 60, height: 25,  "padX": 6, "padY": 12},

      { x: 230, y: 270, width: 60, height: 40,  "padX": 6, "padY": 12},
      { x: 295, y: 220, width: 60, height: 50,  "padX": 6, "padY": 12},
      { x: 270, y: 70, width: 120, height: 230,  "padX": 6, "padY": 12},

    ],
    npcs: [
      {
        id: "MagmaGrunt2",
        x: 245,
        y: 170,
        width: 16,
        height: 24,
        sprite: "/Trainers/team-magma-grunt.png",
        type: "grunt"
      }
    ],
    isIndoor: true,
    floorNumber: 2
  },
  battleTower3: {
    showSteamEffects: true,
    steamPoints: [
      { x: 180, y: 180 }, { x: 200, y: 185 }, { x: 220, y: 175 }, { x: 240, y: 180 },
      { x: 280, y: 190 }, { x: 300, y: 185 }, { x: 320, y: 195 },
      { x: 190, y: 140 }, { x: 250, y: 145 }, { x: 310, y: 150 },
      { x: 170, y: 220 }, { x: 210, y: 225 }, { x: 270, y: 230 }, { x: 320, y: 235 }
    ],
    battleBackground: "/Battle/FireCave.png",
    image: magmaTower3Img,
    characterSprite: charSprite,
    lureImages: {
      lureImg,
      superLureImg,
      ultraLureImg
    },
    width: 368,
    height: 368,
    tileSize: 8,
    viewport: { width: 336, height: 240 },
    initialPlayer: { x: 158, y: 220, direction: "right", step: 0 },
    collisionAreas: [
      { x: 66, y: 76, width: 1, height: 245,  "padX": 6, "padY": 12},

      { x: 60, y: 80, width: 225, height: 1,  "padX": 6, "padY": 12},
      { x: 50, y: 75, width: 80, height: 40,  "padX": 6, "padY": 12},

      { x: 140, y: 155, width: 95, height: 50,  "padX": 6, "padY": 12},


      { x: 140, y: 135, width: 75, height: 20,  "padX": 6, "padY": 12},

      { x: 140, y: 205, width: 65, height: 20,  "padX": 6, "padY": 12},

      { x: 80, y: 185, width: 65, height: 20,  "padX": 6, "padY": 12},
      { x: 155, y: 125, width: 50, height: 20,  "padX": 6, "padY": 12},

      { x: 80, y: 105, width: 20, height: 80,  "padX": 6, "padY": 12},

      { x: 85, y: 230, width: 60, height: 50,  "padX": 6, "padY": 12},

      { x: 100, y: 266, width: 190, height: 40,  "padX": 6, "padY": 12},
      { x: 290, y: 70, width: 120, height: 230,  "padX": 6, "padY": 12},



      { x: 265, y: 245, width: 25, height: 20,  "padX": 6, "padY": 12},

    ],
    npcs: [
      {
        id: "MagmaGrunt3",
        x: 268,
        y: 100,
        width: 16,
        height: 24,
        sprite: "/Trainers/team-magma-grunt.png",
        type: "grunt"
      }
    ],
    isIndoor: true,
    floorNumber: 3
  },

  battleinfiniteTower1: {
    battleBackground: "/Battle/CaveBG.png",
    image: magmaTower1Img,
    characterSprite: charSprite,
    lureImages: {
      lureImg,
      superLureImg,
      ultraLureImg
    },
    width: 368,
    height: 368,
    tileSize: 8,
    viewport: { width: 336, height: 240 },
    initialPlayer: { x: 128, y: 220, direction: "up", step: 0 },
    collisionAreas: [
      { x: 76, y: 76, width: 1, height: 245,  "padX": 6, "padY": 12},
      { x: 60, y: 285, width: 225, height: 1,  "padX": 6, "padY": 12},
      { x: 60, y: 70, width: 225, height: 1,  "padX": 6, "padY": 12},
      { x: 55, y: 75, width: 80, height: 12,  "padX": 6, "padY": 12},
      { x: 150, y: 150, width: 80, height: 1,  "padX": 6, "padY": 12},
      { x: 170, y: 120, width: 80, height: 1,  "padX": 6, "padY": 12},
      { x: 170, y: 135, width: 80, height: 5,  "padX": 6, "padY": 12},
      { x: 137, y: 155, width: 180, height: 55,  "padX": 6, "padY": 12},
      { x: 167, y: 205, width: 60, height: 25,  "padX": 6, "padY": 12},
      { x: 39, y: 270, width: 60, height: 25,  "padX": 6, "padY": 12},
      { x: 270, y: 270, width: 60, height: 25,  "padX": 6, "padY": 12},
      { x: 295, y: 220, width: 60, height: 50,  "padX": 6, "padY": 12},
      { x: 275, y: 70, width: 60, height: 50,  "padX": 6, "padY": 12},
      { x: 225, y: 110, width: 60, height: 50,  "padX": 6, "padY": 12},
    ],
    npcs: [
      {
        id: "Trainer1",
        x: 210,
        y: 100,
        width: 16,
        height: 24,
        sprite: "/Trainers/battle-tower-1.png",
        type: "endless"
      }
    ],
    isIndoor: true,
    floorNumber: 1
  },
  battleinfiniteTower2: {
    showSteamEffects: false,
    steamPoints: [
      { x: 180, y: 180 }, { x: 200, y: 185 }, { x: 220, y: 175 }, { x: 240, y: 180 },
      { x: 280, y: 190 }, { x: 300, y: 185 }, { x: 320, y: 195 },
      { x: 190, y: 140 }, { x: 250, y: 145 }, { x: 310, y: 150 },
      { x: 170, y: 220 }, { x: 210, y: 225 }, { x: 270, y: 230 }, { x: 320, y: 235 }
    ],
    battleBackground: "/Battle/FireCave.png",
    image: magmaTower2Img,
    characterSprite: charSprite,
    lureImages: {
      lureImg,
      superLureImg,
      ultraLureImg
    },
    width: 368,
    height: 368,
    tileSize: 8,
    viewport: { width: 336, height: 240 },
    initialPlayer: { x: 72, y: 180, direction: "down", step: 0 },
    collisionAreas: [
      { x: 66, y: 76, width: 1, height: 245,  "padX": 6, "padY": 12},
      { x: 60, y: 285, width: 225, height: 1,  "padX": 6, "padY": 12},
      { x: 60, y: 70, width: 225, height: 1,  "padX": 6, "padY": 12},
      { x: 55, y: 75, width: 80, height: 50,  "padX": 6, "padY": 12},

      { x: 120, y: 155, width: 95, height: 80,  "padX": 6, "padY": 12},


      { x: 100, y: 135, width: 85, height: 20,  "padX": 6, "padY": 12},
      { x: 100, y: 125, width: 85, height: 20,  "padX": 6, "padY": 12},

      { x: 80, y: 155, width: 85, height: 20,  "padX": 6, "padY": 12},


      { x: 39, y: 270, width: 60, height: 25,  "padX": 6, "padY": 12},

      { x: 230, y: 270, width: 60, height: 40,  "padX": 6, "padY": 12},
      { x: 295, y: 220, width: 60, height: 50,  "padX": 6, "padY": 12},
      { x: 270, y: 70, width: 120, height: 230,  "padX": 6, "padY": 12},

    ],
    npcs: [
      {
        id: "Trainer2",
        x: 245,
        y: 170,
        width: 16,
        height: 24,
        sprite: "/Trainers/battle-tower-1.png",
        type: "endless"
      }
    ],
    isIndoor: true,
    floorNumber: 2
  },
  battleinfiniteTower3: {
    showSteamEffects: false,
    steamPoints: [
      { x: 180, y: 180 }, { x: 200, y: 185 }, { x: 220, y: 175 }, { x: 240, y: 180 },
      { x: 280, y: 190 }, { x: 300, y: 185 }, { x: 320, y: 195 },
      { x: 190, y: 140 }, { x: 250, y: 145 }, { x: 310, y: 150 },
      { x: 170, y: 220 }, { x: 210, y: 225 }, { x: 270, y: 230 }, { x: 320, y: 235 }
    ],
    battleBackground: "/Battle/green.png",
    image: magmaTower3Img,
    characterSprite: charSprite,
    lureImages: {
      lureImg,
      superLureImg,
      ultraLureImg
    },
    width: 368,
    height: 368,
    tileSize: 8,
    viewport: { width: 336, height: 240 },
    initialPlayer: { x: 158, y: 220, direction: "right", step: 0 },
    collisionAreas: [
      { x: 66, y: 76, width: 1, height: 245,  "padX": 6, "padY": 12},

      { x: 60, y: 80, width: 225, height: 1,  "padX": 6, "padY": 12},
      { x: 50, y: 75, width: 80, height: 40,  "padX": 6, "padY": 12},

      { x: 140, y: 155, width: 95, height: 50,  "padX": 6, "padY": 12},


      { x: 140, y: 135, width: 75, height: 20,  "padX": 6, "padY": 12},

      { x: 140, y: 205, width: 65, height: 20,  "padX": 6, "padY": 12},

      { x: 80, y: 185, width: 65, height: 20,  "padX": 6, "padY": 12},
      { x: 155, y: 125, width: 50, height: 20,  "padX": 6, "padY": 12},

      { x: 80, y: 105, width: 20, height: 80,  "padX": 6, "padY": 12},

      { x: 85, y: 230, width: 60, height: 50,  "padX": 6, "padY": 12},

      { x: 100, y: 266, width: 190, height: 40,  "padX": 6, "padY": 12},
      { x: 290, y: 70, width: 120, height: 230,  "padX": 6, "padY": 12},



      { x: 265, y: 245, width: 25, height: 20,  "padX": 6, "padY": 12},

    ],
    npcs: [
      {
        id: "Trainer",
        x: 268,
        y: 100,
        width: 16,
        height: 24,
        sprite: "/Trainers/battle-tower-1.png",
        type: "endless"
      }
    ],
    isIndoor: true,
    floorNumber: 3
  },
  battleMinuteTower1: {
    battleBackground: "/Battle/green.png",
    image: magmaTower1Img,
    characterSprite: charSprite,
    lureImages: {
      lureImg,
      superLureImg,
      ultraLureImg
    },
    width: 368,
    height: 368,
    tileSize: 8,
    viewport: { width: 336, height: 240 },
    initialPlayer: { x: 128, y: 220, direction: "up", step: 0 },
    collisionAreas: [
      { x: 76, y: 76, width: 1, height: 245,  "padX": 6, "padY": 12},
      { x: 60, y: 285, width: 225, height: 1,  "padX": 6, "padY": 12},
      { x: 60, y: 70, width: 225, height: 1,  "padX": 6, "padY": 12},
      { x: 55, y: 75, width: 80, height: 12,  "padX": 6, "padY": 12},
      { x: 150, y: 150, width: 80, height: 1,  "padX": 6, "padY": 12},
      { x: 170, y: 120, width: 80, height: 1,  "padX": 6, "padY": 12},
      { x: 170, y: 135, width: 80, height: 5,  "padX": 6, "padY": 12},
      { x: 137, y: 155, width: 180, height: 55,  "padX": 6, "padY": 12},
      { x: 167, y: 205, width: 60, height: 25,  "padX": 6, "padY": 12},
      { x: 39, y: 270, width: 60, height: 25,  "padX": 6, "padY": 12},
      { x: 270, y: 270, width: 60, height: 25,  "padX": 6, "padY": 12},
      { x: 295, y: 220, width: 60, height: 50,  "padX": 6, "padY": 12},
      { x: 275, y: 70, width: 60, height: 50,  "padX": 6, "padY": 12},
      { x: 225, y: 110, width: 60, height: 50,  "padX": 6, "padY": 12},
    ],
    npcs: [
      {
        id: "Trainer",
        x: 210,
        y: 100,
        width: 16,
        height: 24,
        sprite: "/Trainers/battle-tower-1.png",
        type: "minute"
      }
    ],
    isIndoor: true,
    floorNumber: 1
  },
  battleMinuteTower2: {
    showSteamEffects: true,
    steamPoints: [
      { x: 180, y: 180 }, { x: 200, y: 185 }, { x: 220, y: 175 }, { x: 240, y: 180 },
      { x: 280, y: 190 }, { x: 300, y: 185 }, { x: 320, y: 195 },
      { x: 190, y: 140 }, { x: 250, y: 145 }, { x: 310, y: 150 },
      { x: 170, y: 220 }, { x: 210, y: 225 }, { x: 270, y: 230 }, { x: 320, y: 235 }
    ],
    battleBackground: "/Battle/FireCave.png",
    image: magmaTower2Img,
    characterSprite: charSprite,
    lureImages: {
      lureImg,
      superLureImg,
      ultraLureImg
    },
    width: 368,
    height: 368,
    tileSize: 8,
    viewport: { width: 336, height: 240 },
    initialPlayer: { x: 72, y: 180, direction: "down", step: 0 },
    collisionAreas: [
      { x: 66, y: 76, width: 1, height: 245,  "padX": 6, "padY": 12},
      { x: 60, y: 285, width: 225, height: 1,  "padX": 6, "padY": 12},
      { x: 60, y: 70, width: 225, height: 1,  "padX": 6, "padY": 12},
      { x: 55, y: 75, width: 80, height: 50,  "padX": 6, "padY": 12},

      { x: 120, y: 155, width: 95, height: 80,  "padX": 6, "padY": 12},


      { x: 100, y: 135, width: 85, height: 20,  "padX": 6, "padY": 12},
      { x: 100, y: 125, width: 85, height: 20,  "padX": 6, "padY": 12},

      { x: 80, y: 155, width: 85, height: 20,  "padX": 6, "padY": 12},


      { x: 39, y: 270, width: 60, height: 25,  "padX": 6, "padY": 12},

      { x: 230, y: 270, width: 60, height: 40,  "padX": 6, "padY": 12},
      { x: 295, y: 220, width: 60, height: 50,  "padX": 6, "padY": 12},
      { x: 270, y: 70, width: 120, height: 230,  "padX": 6, "padY": 12},

    ],
    npcs: [
      {
        id: "Trainer",
        x: 245,
        y: 170,
        width: 16,
        height: 24,
        sprite: "/Trainers/battle-tower-1.png",
        type: "minute"
      }
    ],
    isIndoor: true,
    floorNumber: 2
  },
  battleMinuteTower3: {
    showSteamEffects: true,
    steamPoints: [
      { x: 180, y: 180 }, { x: 200, y: 185 }, { x: 220, y: 175 }, { x: 240, y: 180 },
      { x: 280, y: 190 }, { x: 300, y: 185 }, { x: 320, y: 195 },
      { x: 190, y: 140 }, { x: 250, y: 145 }, { x: 310, y: 150 },
      { x: 170, y: 220 }, { x: 210, y: 225 }, { x: 270, y: 230 }, { x: 320, y: 235 }
    ],
    battleBackground: "/Battle/green.png",
    image: magmaTower3Img,
    characterSprite: charSprite,
    lureImages: {
      lureImg,
      superLureImg,
      ultraLureImg
    },
    width: 368,
    height: 368,
    tileSize: 8,
    viewport: { width: 336, height: 240 },
    initialPlayer: { x: 158, y: 220, direction: "right", step: 0 },
    collisionAreas: [
      { x: 66, y: 76, width: 1, height: 245,  "padX": 6, "padY": 12},

      { x: 60, y: 80, width: 225, height: 1,  "padX": 6, "padY": 12},
      { x: 50, y: 75, width: 80, height: 40,  "padX": 6, "padY": 12},

      { x: 140, y: 155, width: 95, height: 50,  "padX": 6, "padY": 12},


      { x: 140, y: 135, width: 75, height: 20,  "padX": 6, "padY": 12},

      { x: 140, y: 205, width: 65, height: 20,  "padX": 6, "padY": 12},

      { x: 80, y: 185, width: 65, height: 20,  "padX": 6, "padY": 12},
      { x: 155, y: 125, width: 50, height: 20,  "padX": 6, "padY": 12},

      { x: 80, y: 105, width: 20, height: 80,  "padX": 6, "padY": 12},

      { x: 85, y: 230, width: 60, height: 50,  "padX": 6, "padY": 12},

      { x: 100, y: 266, width: 190, height: 40,  "padX": 6, "padY": 12},
      { x: 290, y: 70, width: 120, height: 230,  "padX": 6, "padY": 12},



      { x: 265, y: 245, width: 25, height: 20,  "padX": 6, "padY": 12},

    ],
    npcs: [
      {
        id: "Trainer",
        x: 268,
        y: 100,
        width: 16,
        height: 24,
        sprite: "/Trainers/battle-tower-1.png",
        type: "minute"
      }
    ],
    isIndoor: true,
    floorNumber: 3
  },
  battleTower100: {
    showSteamEffects: true,
    steamPoints: [
      { x: 180, y: 180 }, { x: 200, y: 185 }, { x: 220, y: 175 }, { x: 240, y: 180 },
      { x: 280, y: 190 }, { x: 300, y: 185 }, { x: 320, y: 195 },
      { x: 190, y: 140 }, { x: 250, y: 145 }, { x: 310, y: 150 },
      { x: 170, y: 220 }, { x: 210, y: 225 }, { x: 270, y: 230 }, { x: 320, y: 235 }
    ],
    battleBackground: "/Battle/FireBG.png",
    image: magmaTower3Img,
    characterSprite: charSprite,
    lureImages: {
      lureImg,
      superLureImg,
      ultraLureImg
    },
    width: 368,
    height: 368,
    tileSize: 8,
    viewport: { width: 336, height: 240 },
    initialPlayer: { x: 148, y: 220, direction: "right", step: 0 },
    collisionAreas: [
      { x: 66, y: 76, width: 1, height: 245,  "padX": 6, "padY": 12},

      { x: 60, y: 80, width: 225, height: 1,  "padX": 6, "padY": 12},
      { x: 50, y: 75, width: 80, height: 40,  "padX": 6, "padY": 12},

      { x: 140, y: 155, width: 95, height: 50,  "padX": 6, "padY": 12},


      { x: 140, y: 135, width: 75, height: 20,  "padX": 6, "padY": 12},

      { x: 140, y: 205, width: 65, height: 20,  "padX": 6, "padY": 12},

      { x: 80, y: 185, width: 65, height: 20,  "padX": 6, "padY": 12},
      { x: 155, y: 125, width: 50, height: 20,  "padX": 6, "padY": 12},

      { x: 80, y: 105, width: 20, height: 80,  "padX": 6, "padY": 12},

      { x: 85, y: 230, width: 60, height: 50,  "padX": 6, "padY": 12},

      { x: 100, y: 266, width: 190, height: 40,  "padX": 6, "padY": 12},
      { x: 290, y: 70, width: 120, height: 230,  "padX": 6, "padY": 12},



      { x: 265, y: 245, width: 25, height: 20,  "padX": 6, "padY": 12},
    ],
    npcs: [
      {
        id: "Maxie",
        x: 140,
        y: 80,
        width: 16,
        height: 24,
        sprite: "/Trainers/Maxie.png",
        type: "maxie"
      }
    ],
    isIndoor: true,
    floorNumber: 100
  },
  battleTowerGroudon: {
    showSteamEffects: true,
    steamPoints: [
      { x: 180, y: 180 }, { x: 200, y: 185 }, { x: 220, y: 175 }, { x: 240, y: 180 },
      { x: 280, y: 190 }, { x: 300, y: 185 }, { x: 320, y: 195 },
      { x: 190, y: 140 }, { x: 250, y: 145 }, { x: 310, y: 150 },
      { x: 170, y: 220 }, { x: 210, y: 225 }, { x: 270, y: 230 }, { x: 320, y: 235 }
    ],
    battleBackground: "/Battle/magma.png",
    image: groudonChamberImg,
    characterSprite: charSprite,
    lureImages: {
      lureImg,
      superLureImg,
      ultraLureImg
    },
    width: 368,
    height: 368,
    tileSize: 8,
    viewport: { width: 336, height: 240 },
    initialPlayer: { x: 128, y: 220, direction: "up", step: 0 },
    collisionAreas: [

    ],
    npcs: [
      {
        id: "Groudon",
        x: 160,
        y: 170,
        width: 32,
        height: 32,
        sprite: "/Pokemon/GroudonOverworld.png", // Will be dynamically set to diamondGroudon.png for first 15
        type: "groudon"
      }
    ],
    isIndoor: true,
    floorNumber: 101
  },
  safariZoneNorth: {
    id: 26,
    image: safarizonenorthImg,
    characterSprite: charSprite,
    lureImages: {
      lureImg,
      superLureImg,
      ultraLureImg
    },
    width: 800,
    height: 600,
    tileSize: 8,
    viewport: { width: 336, height: 240 },
    initialPlayer: { x: 752, y: 488, direction: "left", step: 0 },
    collisionAreas: [
      // Add collision areas here as needed
      { x: 460, y: 542, width: 20, height: 200,  "padX": 6, "padY": 12},
      { x: 460, y: 508, width: 20, height: 20,  "padX": 6, "padY": 12},
      { x: 542, y: 440, width: 20, height: 20,  "padX": 6, "padY": 12},
      { x: 542, y: 430, width: 45, height: 20,  "padX": 6, "padY": 12},
      { x: 542, y: 390, width: 10, height: 60,  "padX": 6, "padY": 12},
      { x: 348, y: 542, width: 120, height: 200,  "padX": 6, "padY": 12},
      { x: 420, y: 435, width: 15, height: 200,  "padX": 6, "padY": 12},
      { x: 509, y: 545, width: 270, height: 200,  "padX": 6, "padY": 12},
      { x: 632, y: 430, width: 139, height: 19,  "padX": 6, "padY": 12},
      { x: 755, y: 245, width: 20, height: 200,  "padX": 6, "padY": 12},
      { x: 776, y: 15, width: 20, height: 469,  "padX": 6, "padY": 12},
      { x: 700, y: 289, width: 10, height: 98,  "padX": 6, "padY": 12},
      { x: 624, y: 250, width: 10, height: 47,  "padX": 6, "padY": 12},
      { x: 623, y: 285, width: 30, height: 19,  "padX": 6, "padY": 12},
      { x: 547, y: 385, width: 155, height: 2,  "padX": 6, "padY": 12},
      { x: 624, y: 238, width: 155, height: 2,  "padX": 6, "padY": 12},
      { x: 16, y: 0, width: 750, height: 65,  "padX": 6, "padY": 12},
      { x: 40, y: 0, width: 98, height: 600,  "padX": 6, "padY": 12},
      { x: 40, y: 0, width: 98, height: 600,  "padX": 6, "padY": 12},
      { x: 669, y: 85, width: 85, height: 60,  "padX": 6, "padY": 12},
      { x: 136, y: 545, width: 20, height: 60,  "padX": 6, "padY": 12},
      { x: 190, y: 545, width: 130, height: 60,  "padX": 6, "padY": 12},
      { x: 220, y: 370, width: 20, height: 180,  "padX": 6, "padY": 12},
      // { x: 210, y: 270, width: 60, height: 95,  "padX": 6, "padY": 12},
      { x: 210, y: 270, width: 5, height: 95,  "padX": 6, "padY": 12},
      { x: 210, y: 270, width: 60, height: 5,  "padX": 6, "padY": 12},
      { x: 269, y: 270, width: 1, height: 100,  "padX": 6, "padY": 12},
      { x: 210, y: 365, width: 60, height: 3,  "padX": 6, "padY": 12},
      // water area { x: 276, y: 176, width: 60, height: 95,  "padX": 6, "padY": 12},
      { x: 276, y: 176, width: 1, height: 95,  "padX": 6, "padY": 12},
      { x: 276, y: 176, width:58, height: 5,  "padX": 6, "padY": 12},
      { x: 327, y: 176, width:6, height: 96,  "padX": 6, "padY": 12},
      { x: 275, y: 265, width:60, height: 5,  "padX": 6, "padY": 12},
      { x: 147, y: 200, width: 40, height: 50,  "padX": 6, "padY": 12},
      // water area { x: 275, y: 418, width: 60, height: 77,  "padX": 6, "padY": 12},
      { x: 275, y: 418, width: 1, height: 77,  "padX": 6, "padY": 12},
      { x: 275, y: 418, width: 60, height:1,  "padX": 6, "padY": 12},
      { x: 325, y: 418, width: 10, height:78,  "padX": 6, "padY": 12},
      { x: 275, y: 490, width: 60, height:5,  "padX": 6, "padY": 12},
      { x: 147, y: 200, width: 40, height: 50,  "padX": 6, "padY": 12},
      { x: 368, y: 495, width: 20, height: 20,  "padX": 6, "padY": 12},
      { x: 302, y: 120, width: 50, height: 54,  "padX": 6, "padY": 12},
      { x: 353, y: 125, width: 110, height: 20,  "padX": 6, "padY": 12},
      { x: 465, y: 120, width: 50, height: 54,  "padX": 6, "padY": 12},
      { x: 504, y: 125, width: 40, height: 20,  "padX": 6, "padY": 12},
      { x:440, y: 220, width: 197, height: 20,  "padX": 6, "padY": 12},
      { x: 397, y: 203, width: 50, height: 54,  "padX": 6, "padY": 12},
      { x: 397, y:255, width: 20, height: 79,  "padX": 6, "padY": 12},
      { x: 370, y:345, width: 10, height: 98,  "padX": 6, "padY": 12},
      { x: 408, y:335, width: 120, height: 2,  "padX": 6, "padY": 12},
      { x: 530, y:340, width: 10, height: 55,  "padX": 6, "padY": 12},
      { x: 517, y:385, width: 20, height: 17,  "padX": 6, "padY": 12},
      { x: 424, y:430, width: 40, height: 17,  "padX": 6, "padY": 12},
      { x: 449, y:387, width: 18, height: 60,  "padX": 6, "padY": 12},
      { x: 449, y:387, width: 25, height: 12,  "padX": 6, "padY": 12},
      { x:701,y:145,width: 20, height:18, "padX": 6, "padY": 12},
      
    ],
    teleportZones: [
      // Connection to Safari Zone East - right edge of map
      { x: 798, y: 488, width: 5, height: 5, targetFloor: 'safariZoneEast', targetX: 96, targetY: 136 },
      { x: 170, y: 590,width: 5, height: 5, targetFloor: 'safariZoneWest', targetX: 480, targetY: 88},
      { x: 320, y: 568,width: 5, height: 5, targetFloor: 'safariZoneWest', targetX: 592, targetY: 88},
      { x: 483, y: 568,width: 5, height: 5, targetFloor: 'safariZoneSouth', targetX: 400,targetY: 82 },
    ],
    npcs: [
      // Add NPCs here as needed
    ],
    isIndoor: false
  },
  safariZoneEast: {
    id: 25,
    image: safarizoneeastImg,
    characterSprite: charSprite,
    lureImages: {
      lureImg,
      superLureImg,
      ultraLureImg
    },
    width: 864,
    height: 560,
    tileSize: 8,
    viewport: { width: 336, height: 240 },
    initialPlayer: { x: 40, y: 408, direction: "right", step: 0 },
    collisionAreas: [
      // Add collision areas here as needed
      { x: 1, y: 450, width: 140, height: 200, "padX": 6, "padY": 12},
      { x: 1, y: 178, width: 188, height: 230, "padX": 6, "padY": 12},

      { x: 140, y: 475, width: 800, height: 200, "padX": 4, "padY": 12},
      { x: 187, y: 392, width: 131, height: 20, "padX": 9, "padY": 12},
      { x: 310, y: 397, width: 10, height: 45, "padX": 6, "padY": 12},
      { x: 305, y: 436,width: 220, height: 10, "padX": 6, "padY": 12},
      { x: 515, y: 418, width: 10, height: 10, "padX": 6, "padY": 12},
     
      { x: 496, y: 399, width: 80, height: 11, "padX": 12, "padY": 12},
      { x: 411, y: 399,width: 50, height: 14, "padX": 12, "padY": 12},
      { x: 403, y: 376, width: 10, height: 35, "padX": 12, "padY": 20},
      { x: 412, y: 368, width: 173, height: 2, "padX": 12, "padY": 12},
      { x: 415, y: 346, width: 168, height: 5, "padX": 6, "padY": 12},
      { x: 415, y: 318, width: 5, height: 30, "padX": 6, "padY": 12},
      { x: 415, y: 318, width: 100, height: 5, "padX": 6, "padY": 12},
      { x: 512, y: 287, width: 5, height: 30, "padX": 6, "padY": 12},
      { x: 580, y: 308, width: 10, height: 55, "padX": 6, "padY": 12},
      { x: 415, y: 240, width: 5, height: 48, "padX": 6, "padY": 12},
      { x: 432, y: 192, width: 30, height: 48, "padX": 6, "padY": 12},
      { x: 419, y: 192, width: 75, height: 9, "padX": 12, "padY": 12},
      { x: 532, y: 192, width: 25, height: 12, "padX": 6, "padY": 12},
      { x: 356, y: 192, width: 25, height: 16, "padX": 6, "padY": 12},
      { x: 624, y: 185, width: 80, height: 55, "padX": 6, "padY": 12},
      { x: 420, y: 240, width: 156, height: 5, "padX": 6, "padY": 12},
      { x: 570, y: 240, width: 5, height: 36, "padX": 6, "padY": 12},
      { x: 720, y: 0, width: 300, height: 600, "padX": 6, "padY": 12},
      { x: 0, y: 0, width: 800, height: 98, "padX": 6, "padY": 12},
      { x: 0, y: 38, width: 140, height: 98, "padX": 6, "padY": 12},
      { x: 136, y: 130, width: 150, height: 16, "padX": 6, "padY": 12},
      { x: 184, y: 174, width: 170, height: 16, "padX": 6, "padY": 12},
      { x: 355, y: 148, width: 10, height: 53, "padX": 6, "padY": 12},
      { x: 547, y: 148, width: 10, height: 53, "padX": 6, "padY": 12},
      { x: 370, y: 142, width: 175, height: 5, "padX": 6, "padY": 12},
      { x: 416, y: 285, width: 100, height: 2, "padX": 6, "padY": 12},
      { x: 612, y: 401, width: 25, height: 10, "padX": 6, "padY": 12},
      { x: 628, y: 305, width: 10, height: 98, "padX": 6, "padY": 12},
      { x: 678, y: 305, width: 45, height: 11, "padX": 6, "padY": 12},
      { x: 712, y: 276, width: 15, height: 30, "padX": 12, "padY": 12},
      { x: 560, y: 270, width: 154, height: 5, "padX": 18, "padY": 12},
      { x: 540, y: 272, width: 20, height: 50, "padX": 6, "padY": 12},
      { x: 560, y: 305, width: 20, height: 20, "padX": 6, "padY": 12},
      { x: 184, y: 345, width: 108, height: 60, "padX": 6, "padY": 12},
      { x: 288, y: 432, width: 20, height: 16, "padX": 6, "padY": 12},
    ],
    teleportZones: [
      // Connection to Safari Zone south - left edge of map
      { x: 8, y: 408, width: 5, height: 5, targetFloor: 'safariZoneSouth', targetX: 696, targetY: 234 },
      // Connection to Safari Zone East - right edge of map
      { x: 32, y: 136, width: 5, height: 5, targetFloor: 'safariZoneNorth', targetX: 752, targetY: 488 }
    ],
    npcs: [
      // Add NPCs here as needed
    ],
    isIndoor: false
  },
  safariZoneSouth: {
    id: 24,
    image: safarizonesouthImg,
    characterSprite: charSprite,
    lureImages: {
      lureImg,
      superLureImg,
      ultraLureImg
    },
    width: 800,
    height: 600,
    tileSize: 8,
    viewport: { width: 336, height: 240 },
    initialPlayer: { x: 400, y: 434, direction: "up", step: 0 },
    collisionAreas: [
      // Add collision areas here as needed - will need to be configured based on the map layout
      { x: 504, y: 475, width: 800, height: 500, "padX": 5, "padY": 12},
      { x: 690, y: 274, width: 800, height: 500, "padX": 6, "padY": 12},
      { x: 690, y: 0, width: 800, height: 232, "padX": 6, "padY": 12},

      
      { x: 432, y: 0, width: 800, height: 98, "padX": 6, "padY": 12},
      { x: 8, y: 0, width: 389, height: 98, "padX": 6, "padY": 12},
      { x: 8, y: 0, width: 130, height: 267, "padX": 6, "padY": 12},
      { x: 0, y: 304, width: 147, height: 267, "padX": 6, "padY": 12},
      { x: 144, y: 478, width: 360, height: 267, "padX": 6, "padY": 12},
      { x: 450, y: 360, width: 80, height: 62, "padX": 6, "padY": 12},
      
      //Doorway left 
      { x: 138, y: 338, width: 150, height: 10, "padX": 6, "padY": 12},
      { x: 288, y: 320, width: 220, height: 10, "padX": 6, "padY": 12},
      { x: 479, y: 305, width: 32, height: 10, "padX": 6, "padY": 12},
      { x: 526, y: 320, width: 18, height: 15, "padX": 8, "padY": 20},
      //water area
      { x: 296, y: 210, width: 244, height: 5, "padX": 6, "padY": 12},
      { x: 290, y: 210, width: 5, height: 95, "padX": 6, "padY": 12},
      { x: 290, y: 302, width: 249, height: 5, "padX": 6, "padY": 12},
      { x: 535, y: 209, width: 5, height: 95, "padX": 6, "padY": 12},

      { x: 400, y: 432, width: 16, height: 10, "padX": 6, "padY": 12},
      { x: 352, y: 98, width: 16, height: 110, "padX": 6, "padY": 12},
      { x: 545, y: 220, width: 150, height: 20, "padX": 6, "padY": 12},

    ],
    teleportZones: [
      // Add teleport zones here as needed - connections to other Safari Zone areas

      { x: 732, y: 244, width: 40, height: 30, targetFloor: 'safariZoneEast', targetX: 88, targetY: 408 },
      { x: 0, y: 266, width: 5, height: 5, targetFloor: 'safariZoneWest', targetX: 608,targetY: 416},
      { x: 400, y: 0, width: 5, height: 5, targetFloor: 'safariZoneNorth', targetX: 480,targetY: 512},

    ],
    npcs: [
      // Add NPCs here as needed
    ],
    isIndoor: false
  },
  safariZoneWest: {
    id: 27,
    image: safarizonewestImg,
    characterSprite: charSprite,
    lureImages: {
      lureImg,
      superLureImg,
      ultraLureImg
    },
    width: 800,
    height: 600,
    tileSize: 8,
    viewport: { width: 336, height: 240 },
    initialPlayer: { x: 400, y: 300, direction: "down", step: 0 },
    collisionAreas: [
      // Add collision areas here as needed - will need to be configured based on the map layout
      { x: 0, y: 0, width: 475, height: 100, "padX": 6, "padY": 12},
      { x: 159, y: 96, width: 100, height: 39, "padX": 6, "padY": 12},
      { x: 0, y: 96, width: 112, height: 520, "padX": 6, "padY": 12},
      { x: 112, y: 489, width: 800, height: 600, "padX": 6, "padY": 12},
      { x: 639, y: 452, width: 130, height: 80, "padX": 6, "padY": 12},
      { x: 639, y: 0, width:600,  height: 412, "padX": 6, "padY": 12},
      { x: 639, y: 0, width:532, height: 232, "padX": 6, "padY": 12},
      { x:531, y: 0, width: 42, height: 200, "padX": 6, "padY": 12},
      { x:531, y: 0, width: 42, height: 328, "padX": 6, "padY": 12},
      { x:256, y: 415, width: 165, height: 12, "padX": 8, "padY": 12},
      { x:183, y: 415, width: 40, height: 12, "padX": 8, "padY": 12},
      { x:420, y: 368, width: 10, height: 45, "padX": 6, "padY": 12},
      { x:421, y: 368, width: 40, height: 10, "padX": 12, "padY": 12},
      // { x:488, y: 368, width: 18, height: 10, "padX": 6, "padY": 12},
      { x:498, y: 368, width: 22, height: 10, "padX": 12, "padY": 12},
      { x:515, y: 320, width: 10, height: 50, "padX": 6, "padY": 12},
      { x:425, y: 320, width: 98, height: 5, "padX": 6, "padY": 12},
      { x:416, y: 201, width: 12, height: 120, "padX": 6, "padY": 12},
      { x:295, y: 189, width: 130, height: 5, "padX": 6, "padY": 12},
      { x:285, y: 196, width: 20, height: 46, "padX": 6, "padY": 12},
      { x:285,y:239, width: 90, height: 78, "padX": 6, "padY": 12},
      { x:369,y:304, width: 16, height: 65, "padX": 6, "padY": 12},
      { x:256,y:96, width: 45, height:65, "padX": 6, "padY": 12},
      { x:180,y:368, width: 10, height:65, "padX": 6, "padY": 12},
      { x:180,y:368, width: 200, height:5, "padX": 6, "padY": 12},
      { x:104,y:318, width: 191, height:5, "padX": 6, "padY": 12},
      { x:112,y:256, width: 191, height:5, "padX": 6, "padY": 12},
      { x:112,y:104, width: 45, height:50, "padX": 6, "padY": 12},
      { x:156,y:128, width: 20, height:25, "padX": 6, "padY": 12},
      { x:240,y:128, width: 20, height:30, "padX": 6, "padY": 12},
      { x:296,y:92, width: 175, height:20, "padX": 6, "padY": 12},
      { x:430,y:139, width: 20, height:20, "padX": 6, "padY": 12},
      { x:509,y:0, width: 20, height:90, "padX": 6, "padY": 12},
      { x:509,y:0, width: 20, height:20, "padX": 6, "padY": 12},
      { x:568,y:0, width: 20, height:90, "padX": 6, "padY": 12},
      { x:620,y:0, width: 20, height:90, "padX": 6, "padY": 12},
      { x:575,y:159, width: 20, height:20, "padX": 6, "padY": 12},
      { x:556,y:412, width: 20, height:20, "padX": 6, "padY": 12},
      { x:429,y:419, width: 20, height:20, "padX": 6, "padY": 12},
      { x:446,y:424, width: 20, height:65, "padX": 6, "padY": 12},
      // { x:280, y: 256, width: 20, height: 46, "padX": 6, "padY": 12},

      
    ],
    teleportZones: [
      // Add teleport zones here as needed - connections to other Safari Zone areas
      { x: 482, y: 15, width: 5, height: 5, targetFloor: 'safariZoneNorth', targetX: 155, targetY: 512  },
      { x: 592, y: 8,width: 5, height: 5, targetFloor: 'safariZoneNorth', targetX: 315, targetY: 512},
      { x: 736, y: 408, width: 5, height: 5, targetFloor: 'safariZoneSouth', targetX: 136, targetY: 266}
    ],
    npcs: [
      // Add NPCs here as needed
    ],
    isIndoor: false
  },
  entrance: {
    id: 2,
    battleBackground: "/Battle/grass.png",
    image: entranceImg,
    characterSprite: charSprite,
    lureImages: {
      lureImg,
      superLureImg,
      ultraLureImg
    },
    width: 336,
    height: 240,
    tileSize: 8,
    viewport: { width: 336, height: 240 },
    initialPlayer: { x: 58, y: 72, direction: "up", step: 0 },
    collisionAreas: [
      // Add collision areas here as needed - will need to be configured based on the map layout
      { x:35, y:25, width: 16, height:98, "padX": 6, "padY": 12},
      { x:36, y:130, width: 80, height:10, "padX": 6, "padY": 12},
      { x:98, y:25, width: 16, height:98, "padX": 6, "padY": 12},
      { x:36, y:25, width: 80, height:10, "padX": 6, "padY": 12},
    ],
    teleportZones: [
      // Add teleport zones here as needed - connections to other maps
    ],
    npcs: [
      {
        id: "SafraiZone",
        x: 18,
        y: 60,
        width: 16,
        height: 24,
        sprite: "/Trainers/safrai-zon.png",
        type: "SafraiZone"
      },
    ],
    isIndoor: false
  },
  battletowerentrance: {
    id: 2,
    battleBackground: "/Battle/grass.png",
    image: entranceImg,
    characterSprite: charSprite,
    lureImages: {
      lureImg,
      superLureImg,
      ultraLureImg
    },
    width: 336,
    height: 240,
    tileSize: 8,
    viewport: { width: 336, height: 240 },
    initialPlayer: { x: 58, y: 72, direction: "up", step: 0 },
    collisionAreas: [
      // Add collision areas here as needed - will need to be configured based on the map layout
      { x:35, y:25, width: 16, height:98, "padX": 6, "padY": 12},
      { x:36, y:130, width: 80, height:10, "padX": 6, "padY": 12},
      { x:98, y:25, width: 16, height:98, "padX": 6, "padY": 12},
      { x:36, y:25, width: 80, height:10, "padX": 6, "padY": 12},
    ],
    teleportZones: [
      // Add teleport zones here as needed - connections to other maps
    ],
    npcs: [
      {
        id: "SafraiZone",
        x: 18,
        y: 60,
        width: 16,
        height: 24,
        sprite: "/Trainers/safrai-zon.png",
        type: "SafraiZone"
      },
    ],
    isIndoor: false
  },
};